/*-----------------------------------------------------*/
/*----------------Mobile Detect------------------------*/
/*-----------------------------------------------------*/    


var md = new MobileDetect(window.navigator.userAgent); 
let isMobile = md.mobile();

//console.log(isMobile);

/*-----------------------------------------------------*/
/*----------------End Mobile Detect--------------------*/
/*-----------------------------------------------------*/    


function vimeoVideo(videoId,containerID,vQuality,videoLoop,videoAutoPlay,videoMuted,videoControls){
  let options = {
    id: videoId,
    loop: videoLoop,//true
    autoplay: videoAutoPlay,//true
    muted:videoMuted,//true
    controls: videoControls,//false
    autopause: false 
};
let playerDefault = new Vimeo.Player(containerID, options);
var videoQuality = vQuality ;

playerDefault.setQuality(videoQuality).then(function(videoQuality) {
   // console.log(videoQuality);
    playerDefault.on('play', function() {
      //console.log('played the video!');
    });
  
   }).catch(function(error) {
    switch (error.name) {
      case 'TypeError':
      break;
  
      default:
      break;
    }
   });
}

let atcText = document.getElementById("atc_txt").getAttribute("data-atc");
let soldText = document.getElementById("atc_txt").getAttribute("data-sold");

/*-----------------------------------------------------*/
/*----------------Announcement Bar Start---------------*/
/*-----------------------------------------------------*/                              

let trutTimer = setInterval(autoRotateTrust, 3500);
let announcementCounter = $(".announcement_item").length;
let announcementItem = 1;

$(".annou-id-1").css({ "opacity": 1, "display": "flex" });

function autoRotateTrust(){
       if(announcementItem < announcementCounter){
           announcementItem++;
        }
       else{
           announcementItem = 1;
        }
      $(".announcement_item").css({ "opacity": 0, "display": "none" });
      anime({
            targets: ".annou-id-"+announcementItem+"",
            opacity: [0,1],
            duration:500,
            easing: 'easeInOutSine',
            begin: function(anim) {
                 $(".annou-id-"+announcementItem+"").css("display","flex");
              }
      });
}

$(".bambino_header_announcement_wrapper").hover(
  () => {
     clearInterval(trutTimer);
  },
  () => {    
    trutTimer = setInterval(autoRotateTrust,3500);     
  }
)
/*-----------------------------------------------------*/
/*-----------------Announcement Bar End----------------*/
/*-----------------------------------------------------*/   

var dropdownControl = 0;
let indexit = $(".filter_dropdown").find("svg");
         


document.addEventListener("click", (evt) => {
 
     let $target = $(evt.target);
     if($target.closest('#Search').length === 0 && $('#Search').attr("data-position") == 'open' && $target.closest('.item_search').length === 0 && $('.item_search').attr('data-position') == 'open' ){; 
         reverseAnimation();
     }

     if($target.closest('.filter_dropdown').length === 0 && $target.closest('.parent-display').length === 0  ){; 
       $(".filter_dropdown").find("svg").removeClass('rotate_icon');
       dropdownControl = 0;
       $('.disclosure-has-popup').removeAttr('open');
     }

     if($target.closest('.size_select_pdp').length === 0){; 
      anime({
        targets : '.pdp_size_dropdown',
        duration : 500,
        easing: 'easeOutQuart',
        translateY: [0 , -10],
        opacity: [1,0],
        complete: () => {
          $(".pdp_size_dropdown").attr("data-position","close");
          $(".pdp_size_dropdown").css("display","none");
      }
    });
  }

  if($target.closest('.size_select_pdp-feat').length === 0 ){
    anime({
      targets : '.pdp_size_dropdown-feat',
      duration : 500,
      easing: 'easeOutQuart',
      translateY: [0 , -10],
      opacity: [1,0],
      complete: () => {
        $(".pdp_size_dropdown-feat").attr("data-position","close");
        $(".pdp_size_dropdown-feat").css("display","none");
    }
  })
  }

  if($target.closest('.size_variant_modal').length === 0 && $target.closest('.select_options').length === 0 && $target.closest('.select_box_modal').length === 0 ){
    anime({
      targets: '.select_options',
      duration: 500,
      easing: 'easeOutQuart',
      opacity: [1,0],
      bottom: ['35px','0px'],
      complete: () => {
        $(".select_options").css("display","none");
        $('.select_options').attr('data-position','close');
    }
    })

  }


});



$(document).on('click','.filter_dropdown', function (){
       if(dropdownControl == 0){
          $(".filter_dropdown").find("svg").addClass('rotate_icon');
          dropdownControl = 1;
         }
         else{

          $(".filter_dropdown").find("svg").removeClass('rotate_icon');
          dropdownControl = 0;
         }
        }
        );


$(document).on('click','.item_search', function (){

$('#Search').val(""); 
$('#predictive-search').attr('style',''); 
$('#predictive-search').find('div').remove();
$('#predictive-search').find('span').remove();
$(this).attr("data-position","open"); 
$('#Search').attr("data-position","open"); 
if(isMobile == null){
        anime({
            targets: '.item_account',
            duration: 200,
            opacity:[1,0],
            easing: 'easeOutQuart',
            complete: function() {
                 $('.item_account').hide();
            }
            });

        anime({
           targets: '.item_cart',
           duration: 200,
           opacity:[1,0],
           easing: 'easeOutQuart',
           complete: function() {
                $('.item_cart').hide();
           }
          });

        anime({
          targets: '.item_country_selector',
          duration: 200,
          opacity:[1,0],
          easing: 'easeOutQuart',
          complete: function() {
          $(".item_search").css("position","relative");
          $('.item_country_selector').hide();
          $(".predictive_search_wrapper").css("display","block");
             anime({
                  targets: '.item_search',
                  translateX: 0,
                  easing: 'easeOutQuart',
                  duration: 200,
                  complete: function() {
                        anime({
                          targets: '.predictive_search_wrapper',
                          easing: 'easeOutQuart',
                          duration: 200,
                          opacity: [0,1], 
                          complete: function() {
                          $("#Search").focus();
                          }
                        })
                  }
             });

            

          }
         });
        }else{
          //mobile
          anime({
            targets: '.item_account',
            duration: 300,
            opacity:[1,0],
            easing: 'easeOutQuart'
            });

        anime({
           targets: '.item_cart',
           duration: 300,
           opacity:[1,0],
           easing: 'easeOutQuart'
          });

          anime({
            targets: '.item_search',
            duration: 300,
            opacity:[1,0],
            easing: 'easeOutQuart'
           });

           anime({
            targets: '.item_country_selector',
            duration: 300,
            opacity:[1,0],
            easing: 'easeOutQuart',
            complete: function() {
              $(".item_search").css("position","relative");
              $(".predictive_search_wrapper").css("display","block");
              anime({
                targets: '.predictive_search_wrapper',
                easing: 'easeOutQuart',
                duration: 500,
                opacity: [0,1], 
                complete: function() {
                $("#Search").focus();
                }
              })
            }
           });


        }
});


function reverseAnimation(){
  if(isMobile == null){
  $('.item_search').attr('data-position','close');
  $('.item_account').show();
  $('.item_cart').show();
  $('.item_country_selector').show();
  $(".predictive_search_wrapper").css("display","none");
  anime({
    targets: '.predictive_search_wrapper',
    easing: 'easeOutQuart',
    duration: 500,
    opacity: [1,0]
  })
  anime({
    targets: '.item_search',
    translateX: 0,
    easing: 'easeOutQuart',
    duration: 500,
    complete: function() {

      anime({
        targets: '.item_account',
        duration: 300,
        opacity:[0,1],
        easing: 'easeOutQuart'
        });

    anime({
       targets: '.item_cart',
       duration: 300,
       opacity:[0,1],
       easing: 'easeOutQuart'
      });

      anime({
        targets: '.item_country_selector',
        easing: 'easeOutQuart',
        duration: 500,
        opacity: [0,1], 
        complete: function(){
          $(".predictive_search_wrapper").css("display","none");
        }
      });

    }
});
}else{
  $('.item_search').attr('data-position','close');
  anime({
    targets: '.predictive_search_wrapper',
    easing: 'easeOutQuart',
    duration: 500,
    opacity: [1,0],
    complete: function() {
      anime({
        targets: '.item_account',
        duration: 300,
        opacity:[0,1],
        easing: 'easeOutQuart'
        });

    anime({
       targets: '.item_cart',
       duration: 300,
       opacity:[0,1],
       easing: 'easeOutQuart'
      });

      anime({
        targets: '.item_country_selector',
        easing: 'easeOutQuart',
        duration: 500,
        opacity: [0,1], 
      })

      anime({
        targets: '.item_search',
        easing: 'easeOutQuart',
        duration: 500,
        opacity: [0,1],
        complete: function(){
          $(".predictive_search_wrapper").css("display","none");
        }
      })
    }
  })
}
}

$(document).on('click','.mobile-search-close', function (){

  reverseAnimation();

});



$(document).ready( function() {


//console.log($('#klarna_pdp').html());

  
  if($('#_product')[0]){
   let activeArticle = $('.grid__item_article').length;
   let activePages = $('.grid__item_page').length;
   let activeProduct = $('.grid__item').length;

  // console.log(activeArticle + " " +activePages)

   let TotalResult = activeArticle + activePages;
   let masterTotalResult = TotalResult + activeProduct;

   $('#result_count').html(masterTotalResult);

   $('#product_num').html(activeProduct);

   if( activeArticle == 0){
       $('.search_article_container').hide();
   }else{
       $('.search_article_container').show();
   }

   $('#article_num').html(TotalResult);

  }



  //Dynamic slider content script{
    const searchParams = new URLSearchParams(window.location.search);

    if($('.clear_all')[0]){
      if(searchParams.has('filter.p.m.custom.product_filters') || searchParams.has('sort_by')){
        $('.clear_all').css('display','flex');        
      }else{
      $('.clear_all').css('display','none');    
      }

}


    let paramArray = searchParams.getAll("anchor");
    let paramArrayTab = searchParams.getAll("tab");
    let getThisID;
    //console.log(searchParams.getAll("anchor")+' '+searchParams.getAll("tab"));
    if(paramArray.length > 0 || paramArrayTab > 0){
       let getArrayParam = paramArray[0];
       let getArrayTabParam = paramArrayTab[0];
       $('.bfcc-item-master').each(function( index ) {
            let getData = $(this).find('.bfcc-item-wrapper ').find('.bfcc-item-richcontent').data('anchor');
            if( getData == getArrayParam) {
              $(this).find('.bfcc-item-wrapper').find('.bfcc-item-richcontent').attr('data-position','open');
              $(this).find('.bfcc-item-wrapper').addClass('active');
              $(this).find('.bfcc-item-wrapper').find('.bfcc-item-richcontent').slideDown();
              $(this).find('.bfcc-item-wrapper').find('.bfcc-item-header').find('a').find('.bfcc-position').html('-');
              $(this).find('.bfcc-item-wrapper').find('.bfcc-item-header').addClass('active');
              getThisID = $(this).find('.bfcc-item-wrapper ').find('.bfcc-item-richcontent').attr('id');
            }   
       });
       $('.nav_item_faq').each(function( index ) {
            let getTab = $(this).attr('data-order');
            if(getArrayTabParam == getTab){
                $(this).trigger('click');
                //$('html,body').animate({scrollTop: $('#'+getThisID+'').offset().top-150},300);
                window.scroll({
                  top: $('#'+getThisID+'').offset().top-150,
                  behavior: "smooth"
              });
            }   
       });
       
    }
    
 

  if($('.filter_dropdown')[0]){
//console.log('visible')
  }else{
    $('.count_wrapper').hide();
  }

  var $recommendedSlider = $( '.drawer_recommended_slider').flickity({  
    cellAlign: "left", 
    contain: false , 
    groupCells: 1,
    pageDots: false ,
    imagesLoaded: true,
    prevNextButtons: false 
  });

  $('.rec_arrows_right').on( 'click', function() {
    $recommendedSlider.flickity('next');
  });
  
  $('.rec_arrows_left').on( 'click', function() {
    $recommendedSlider.flickity('previous');
  });

  $teamquotes = $('.btqc-slider-container ').flickity({  
    cellAlign: "left", 
    contain: false , 
    pageDots: true ,
    imagesLoaded: true,
    prevNextButtons: false 
  });


  $carousel =   $('.carousel').flickity({
    cellAlign: "left", 
    contain: false , 
    pageDots: true ,
    prevNextButtons: true,
    wrapAround: true,
    arrowShape: 'M5.5844506,50.1808511 L75.8703458,50.1808511 L47.2425906,79.3027872 C45.0609319,81.5202128 45.0609319,85.1180851 47.2425906,87.3355106 C48.3334199,88.4451702 49.7611778,89 51.1907972,89 C52.6204165,89 54.0481744,88.4451702 55.1390037,87.3355106 L93.2938317,48.5220426 C93.5563009,48.2550426 93.7908478,47.9634255 93.9974725,47.6490851 C94.0831007,47.5165319 94.1426682,47.372617 94.2171275,47.234383 C94.3195091,47.0488085 94.4293367,46.8689149 94.5093805,46.6719787 C94.5838398,46.4864043 94.6266539,46.2951489 94.6806369,46.1057872 C94.7290355,45.9410426 94.792326,45.7819787 94.8258327,45.6115532 C94.9691669,44.8787234 94.9691669,44.1212766 94.8258327,43.3884468 C94.792326,43.2180213 94.7290355,43.0589574 94.6806369,42.8942128 C94.6266539,42.7048511 94.5838398,42.5117021 94.5093805,42.3280213 C94.4293367,42.1310851 94.3195091,41.9511915 94.2171275,41.765617 C94.1426682,41.627383 94.0831007,41.4834681 93.9974725,41.3509149 C93.7908478,41.0365745 93.5563009,40.7430638 93.2938317,40.4779574 L55.1390037,1.66448936 C52.957345,-0.554829787 49.4242493,-0.554829787 47.2425906,1.66448936 C45.0609319,3.88191489 45.0609319,7.47978723 47.2425906,9.69721277 L75.8703458,38.8191489 L5.5844506,38.8191489 C2.49997238,38.8191489 0,41.3622766 0,44.5 C0,47.6377234 2.49997238,50.1808511 5.5844506,50.1808511 Z'
    });


  $('.btcq_btn_prev').on( 'click', function() {
    $teamquotes.flickity('previous');
  });
  
  $('.btcq_btn_next').on( 'click', function() {
    $teamquotes.flickity('next');
  });

  if ($('.pmw-media-container')[0]){
  $( '.pmw-media-container').flickity({  
    pageDots: true ,
    prevNextButtons: false,
    imagesLoaded: true,
    cellAlign: 'left',
    wrapAround: false,
    watchCSS: true
  });
}


  if ($('.flickity_bambassador')[0]){

  var options = {
    pageDots: true ,
    prevNextButtons: false,
    imagesLoaded: true,
    cellAlign: 'left',
    wrapAround: true
  }  

  if ( matchMedia('screen and (min-width: 1441px) and (max-width: 2000px)').matches ) {
    options.cellAlign = 'center';
  }


  var $bambassadorSlider = $( '.flickity_bambassador').flickity(options);

}

  if ($('.fpc_content')[0]){
  var $featuredProductSlider = $( '.fpc_content').flickity({  
    pageDots: false ,
    prevNextButtons: false,
    imagesLoaded: true,
    cellAlign: 'center',
    wrapAround: true
  });


    $('.fpc_slider_container').css('opacity','1'); 
    $('.fpc_content').flickity('resize');

  }


  

  $('#featured_right').on( 'click', function() {
    $featuredProductSlider.flickity('next');
  });
  
  $('#featured_left').on( 'click', function() {
    $featuredProductSlider.flickity('previous');
  });



  $('#bac-right').on( 'click', function() {
    $bambassadorSlider.flickity('next');
  });
  
  $('#bac-left').on( 'click', function() {
    $bambassadorSlider.flickity('previous');
  });



$( ".ppc_arrow_left" ).each(function( index ) {
  let getID = $(this).attr('id');
  let sectionID = $(this).attr('data-section');
    $('#'+getID+'').on( 'click', function() {
     // console.log('click');
      let $carousel = $('.ppc_content_'+sectionID+'').flickity();
      $carousel.flickity('previous');
});







});

$( ".ppc_arrow_right" ).each(function( index ) {
  let getID = $(this).attr('id');
  let sectionID = $(this).attr('data-section');
    $('#'+getID+'').on( 'click', function() {
     // console.log('click');
      let $carousel = $('.ppc_content_'+sectionID+'').flickity();
      $carousel.flickity('next');
});
});

if ($("#productvideo")[0]){
  let getProductVideoID = $('#productvideo').attr('data-videoid');
  let getProductContainer = 'productvideo';  
  vimeoVideo(getProductVideoID,getProductContainer,'720p',true,true,true,false);
}

if ($("#getCountContainer")[0]){
let dataCount = $('#getCountContainer').data('active');
    if(dataCount == 0){
      $('#mobile_wrapper').css('visibility','hidden');
    }
  }

  var frame = $('#form-iframe-4390');
  frame.on("load",function(e) {
      frame.contents().find('body').css('font-family', 'filson-pro-bold');
  });


});


$(document).on('click','.close__drawer , .drawer_modal_background', function (){
          anime({
            targets: '.bambino-drawer',
            duration: 300,
            translateX:474,
            easing: 'easeOutQuart'
          })

          anime({
             targets:'.drawer_modal_background',
             duration: 300,
             opacity:[1,0],
             easing: 'easeOutQuart',
             complete: () => {
                 $(".drawer_modal_background").css("display","none");
             }
          })
          $(".bambino-drawer").attr("data-position","close");
});

$(document).on('click','.item_cart', function (){
  $(".drawer_modal_background").css("display","block");
  $(".bambino-drawer").attr('data-position','open');
  anime({
    targets: '.bambino-drawer',
    duration: 500,
    translateX:[463,0],
    easing: 'easeOutQuart'
  })

  anime({
     targets:'.drawer_modal_background',
     duration: 1000,
     opacity:[0,1],
     easing: 'easeOutQuart',
  })
});

$(document).ready(function() {


  /*$(".counter").lettering();*/



  if ($(".article_b")[0]){

    let numArticle = $('.article_b').length;
    let totalItem = $('#ProductGridContainer').attr("data-total");
    let productTotal = totalItem - numArticle;
    $("#product_num").html(productTotal);
    $("#article_num").html(numArticle);
   

  }
  else{
    if ($(".product_b")[0]){
      let totalItem = $('#ProductGridContainer').attr("data-total");
      $("#product_num").html(totalItem);
      $("#article_num").html(0);
   }
}
if ($(".flickity_bambassador")[0]){
  anime({
    targets: '.flickity_bambassador',
    easing: 'easeOutQuart',
    duration: 500,
    opacity: [0,1], 
  })
    $('.flickity_bambassador').flickity('resize');
}
});

var slideControl = 0;
$(document).on('click','.bwitb-header', function (){
         if(slideControl == 0){
          $(this).parent().find(".bwitb-content").slideDown();
          slideControl = 1;
         }
         else{

          $(this).parent().find(".bwitb-content").slideUp();
          slideControl = 0;
         }
         
  
});

var slideControl2 = 0;
$(document).on('click','.witb_collapse', function (){
         if(slideControl2 == 0){
          $(this).parent().find(".ycac-bwitb-content").slideDown();
          slideControl2 = 1;
         }
         else{

          $(this).parent().find(".ycac-bwitb-content").slideUp();
          slideControl2 = 0;
         }
         
  
});





$('.social_icons.facebook').hover(function () {
    anime({
       targets : ".social_icons.facebook",
       duration  : 500,
       scale : [1,1.3],
       easing: 'easeOutQuart',

    })
    
  }, function () {
    anime({
      targets : ".social_icons.facebook",
      duration  : 500,
      scale : [1.3,1],
      easing: 'easeOutQuart',

   })
  }
);


$('.social_icons.instagram').hover(function () {
  anime({
     targets : ".social_icons.instagram",
     duration  : 500,
     scale : [1,1.3],
     easing: 'easeOutQuart',

  })
  
}, function () {
  anime({
    targets : ".social_icons.instagram",
    duration  : 500,
    scale : [1.3,1],
    easing: 'easeOutQuart',

 })
}
);

$('.social_icons.youtube').hover(function () {
  anime({
     targets : ".social_icons.youtube",
     duration  : 500,
     scale : [1,1.3],
     easing: 'easeOutQuart',

  })
  
}, function () {
  anime({
    targets : ".social_icons.youtube",
    duration  : 500,
    scale : [1.3,1],
    easing: 'easeOutQuart',

 })
}
);

$(document).on('click','.size_variant', function (){
     $(".variant__item_holder__size").removeClass('selected_element');
     $(this).parent().addClass('selected_element');
     let showFormat
     let getVariantName = $(this).val();
     let getVariantColor = $(this).data('color');
     if(getVariantName != "" && getVariantColor != "" ) {
        showFormat = "<span>Design:</span> "+getVariantColor+" | <span>Size:</span> "+getVariantName;
      }if(getVariantName == "" && getVariantColor != ""){
        showFormat = "<span>Design:</span> "+getVariantColor;
      }if(getVariantName != "" && getVariantColor == ""){
        showFormat = "<span>Design:</span> "+getVariantName;
      }if(getVariantName == getVariantColor){
        showFormat = "<span>Design:</span> "+getVariantName;
      }


     // console.log(getVariantName+' '+getVariantColor);
    
      let getMID = $(this).attr('data-pid');

      $('.porduct_subcribe').attr('data-modalid',getMID);
     

     $(this).parent().parent().parent().parent().parent().parent().find('.buy_button_section').find('.selected_variant_holder').find('.name_of_variant').html(showFormat);

      let sizeofitems = $(this).parent().parent().parent().find("li").length;
      let megerItem = (sizeofitems * 42) * -1;
      let getID = $(this).parent().parent().parent().attr("id");
      let getIDAddto = $(this).closest('.card__media').find('.buy_button_section').attr('id');
      let getIDLegend = $(this).closest('.card__media').find('.legend').attr('id');
      
      let getProductID = $(this).attr('data-productid');
      $(this).parent().parent().parent().parent().parent().parent().find('.buy_button_section').find('.add_to_card_wrapper').find('a').attr('data-id',getProductID);


    
     anime({
         targets: '#'+getID+'',
         duration : 500,
         easing: 'easeOutQuart',
         bottom: [(megerItem)+'px'],
         opacity: [1,0],complete: () => {
          $(this).parent().parent().parent().css("display","none");
      }
     })
     $(this).closest('.card__media').find('.buy_button_section').css('display','block');
     anime({
      targets : '#'+getIDLegend,
      duration : 500,
      easing: 'easeOutQuart',
      bottom: ['0px','-42px'],
      opacity: [1,0]
      })

     anime({
         targets : '#'+getIDAddto,
         duration : 500,
         easing: 'easeOutQuart',
         bottom: ['-64px','0px'],
         opacity: [0,1],
         complete: () => {
          //$(".card_variants__holder").css("display","none");
      }
     })
});


$(document).on('touchstart touchend click','.legend', function (){
     let sizeofitems = $(this).parent().find("fieldset").find("li").length;
     let sizeFreq = $(this).parent().find("fieldset").find(".displayno").length;
     let megerItem = ((sizeofitems - sizeFreq)  * 42) * -1;
     let getPosition = $(this).parent().find("fieldset").attr("data-position");
     let getID = $(this).parent().find("fieldset").attr("id");
     if(getPosition == "close"){
     $(this).parent().find("fieldset").attr("data-position","open"); 
     $(this).parent().find("fieldset").css("display","block");
    // console.log(getID);
     anime({
         targets: '#'+getID+'',
         duration : 500,
         easing: 'easeOutQuart',
         bottom: [megerItem+'px' , '42px'],
         opacity: [0,1]
     })
    }else{
      anime({
        targets: '#'+getID+'',
        duration : 500,
        easing: 'easeOutQuart',
        bottom: ['42px',megerItem+'px'],
        opacity: [1,0],
        complete: () => {
          $(this).parent().find("fieldset").attr("data-position","close"); 
          $(this).parent().find("fieldset").css("display","none");
      }
    })
    }
});






  $(document).on('click','.variant_col_but', function (){
        let getAnimID = $(this).parent().parent().attr("id");
        let positionStatus = $(this).parent().parent().attr('data-position');


        let getHeight = $(this).parent().parent().parent().find('fieldset').height(); 
//console.log(getHeight)
        if(positionStatus == 'close'){
          $(this).find(".variant_arrow").css("transform","rotate(-135deg)"); 
          anime({
            targets: '#'+getAnimID+'',
            duration: 500,
            easing: 'easeOutQuart',
            height : ['41px', getHeight],
            bottom: '15px',
            complete: () => {
              $('#'+getAnimID+'').attr("data-position","open");
       
          }
        })
        } else{
          $(this).find(".variant_arrow").css("transform","rotate(45deg)");
          anime({
            targets: '#'+getAnimID+'',
            duration: 500,
            easing: 'easeOutQuart',
            height : [getHeight, '41px'],
            bottom: '15px',
            complete: () => {
              $('#'+getAnimID+'').attr("data-position","close");
             
          }
        })

        }
    
      
      }); 



  $(document).on('change','.color_variant', function (){
      
       let getVariantName = $(this).val();
       let getSize = $(this).data('size');
       let showFormat

       if(getVariantName != "" && getSize != "" ) {
        showFormat = "<span>Design:</span> "+getVariantName+" | <span>Size:</span> "+getSize
      }if(getVariantName == "" && getSize != ""){
        showFormat = "<span>Size:</span> "+getSize;
      }if(getVariantName != "" && getSize == ""){
        showFormat = "<span>Design:</span> "+getVariantName;
      }if(getVariantName == getSize){
        showFormat = "<span>Design:</span> "+getVariantName;
      }

      //console.log(getVariantName+' '+getSize);

     

       //console.log(getVariantName);

       let getProductImages = $(this).data('images').split(",");
       let getFirstImage = getProductImages[0];
       let getSecondImage = getProductImages[1];

       $(this).parent().parent().parent().parent().parent().parent().find('.card__media').find('a').find('.media').find('img').remove();
       $(this).parent().parent().parent().parent().parent().parent().find('.card__media').find('a').find('.media').append(`<img class="motion-reduce upper_image" loading="eager" width="410" height="513" src="${getFirstImage}"/>`);

       //console.log($(this).parent().parent().parent().parent().parent().parent().find('.card__media').find('a').find('.media').find('.upper_image').attr('src'));
       

       $(this).parent().parent().parent().parent().parent().parent().find('.buy_button_section').find('.selected_variant_holder').find('.name_of_variant').html(showFormat); 

       let buyButtonStatus = $(this).parent().parent().parent().parent().parent().parent();
       //$('.variant_label').removeClass('active');

       let sizeofActive = $(this).parent().parent().parent().find('li').length;

       for (let i = 0; i < sizeofActive; i++) {
           $(this).parent().parent().parent().find('li').eq(i).find('.variant__item_holder__color').find('.color_variant').removeClass('active');
           $(this).parent().parent().parent().find('li').eq(i).find('.variant__item_holder__color').find('.variant_label').removeClass('active');
        }  
       $(this).parent().find('.variant_label').addClass('active');
       $(this).addClass('active');

       /* manuplation of Variant ID depends selected color variant */

      

       let longPath = $(this).parent().parent().parent().parent().parent().parent().find('.card__media').find('.card_variants__holder').find('.card_variant_content').find('fieldset').find('li');
       let longpath2 = $(this).parent().parent().parent().parent().parent().parent().find('.card__media').find('.card_variants__holder').find('.card_variant_content').find('fieldset');

       let sizeofitems = longPath.length;
       let sizeFreq = longpath2.find(".displayno").length;
       let megerItem = ((sizeofitems - sizeFreq)  * 42) * -1;
       let getID = longpath2.attr("id");
       let getBuyButtonID = $(this).parent().parent().parent().parent().parent().parent().find('.card__media').find('.buy_button_section').attr('id');
       let getProductID = $(this).attr('data-productid');

       $(this).parent().parent().parent().parent().parent().parent().find('.card__media').find('.buy_button_section').find('.add_to_card_wrapper').find('a').attr('data-id',getProductID);

       let getMasterName = $(this).attr('data-vname');
       let manuplationSize = longPath.length;
       for (let i = 0; i < manuplationSize; i++) {
            let getAttr = longPath.eq(i).attr('data-productcolor');
            if(getMasterName == getAttr){
              longPath.eq(i).removeClass('displayno');
            }
            else{
              longPath.eq(i).addClass('displayno');
            }
       }

       anime({
        targets: '#'+getID+'',
        duration : 500,
        easing: 'easeOutQuart',
        bottom: ['42px',megerItem+'px'],
        opacity: [1,0],
        complete: () => {
          longpath2.attr("data-position","close"); 
          longpath2.css("display","none");
      }
    })

    if( buyButtonStatus.hasClass('fullvariant')){


    anime({
      targets: '#'+getBuyButtonID+'',
      duration : 500,
      easing: 'easeOutQuart',
      bottom: '-64px',
      complete: () => {
        longpath2.attr("data-position","close"); 
        longpath2.attr("style","");
        $('.card_variants__holder').css('display','block');
        $(this).parent().parent().parent().parent().parent().parent().find('.card__media').find('.card_variants__holder').find('.card_variant_content').find('.legend').attr('style','');
        $(this).parent().parent().parent().parent().parent().parent().find('.card__media').find('.card_variants__holder').find('.card_variant_content').find('.legend').css('display','flex');
    }
    })

  }

        /* manuplation of Variant ID depends selected color variant */


  }); 


  
$(document).on('click','.reset_selected_variant', function (){
    let getCloseAnimID = $(this).parent().parent().attr("id");
    $(this).parent().parent().parent().find('.card_variants__holder').find('.card_variant_content').find('.legend').attr('style','');
    $(this).parent().parent().parent().find('.card_variants__holder').find('.card_variant_content').find('.legend').css('display','flex');
    $(this).parent().parent().parent().find('.card_variants__holder').find('.card_variant_content').find('fieldset').attr('data-position','close');
    $('.card_variants__holder').css('display','block');
    anime({
      targets: '#'+getCloseAnimID+'',
      duration : 500,
      easing: 'easeOutQuart',
      bottom: ['0px','-64px'], 
     
    })

});

      





 $(document).on('mouseenter','.grid__item', function (event) {
  
  let getStatusofProduct =  $(this).find('.card-wrapper').find('.card').find('.card__inner ');
  let getBuyButtonID =  $(this).find('.card-wrapper').find('.card').find('.card__inner ').find('.card__media').find('.buy_button_section').attr("id");  
  let getPosition = $(this).find('.card-wrapper').find('.card').find('.card__inner ').find('.card__media').find('.buy_button_section').attr("data-position");  
  let sold_out_detect = $(this).find('.product-card-wrapper'); 
   
  if(isMobile == null ){
     if($(this).find('.card-wrapper').find('.card').find('.card__inner').hasClass('nohover')){
       // console.log('nohover active')
     }else{
      $(this).find('.card__media').find('.media').find('img').eq(0).fadeTo(200, 0);
     }
      
  }

  if(sold_out_detect.hasClass('sold_out_product')){
    // console.log('soldout');
  }
  else{
        if(getStatusofProduct.hasClass('onlycolor') || getStatusofProduct.hasClass('novariant'))
        {
          if(isMobile == null){
            $('#'+getBuyButtonID+'').css('display','block');
            anime({
                targets: '#'+getBuyButtonID+'',
                duration : 500,
                easing: 'easeOutQuart',
                bottom: '0px',
                opacity: [0,1],
              
                
            }) 
          }
        }
     }

  let position_effect = $(this).find('.card-wrapper').find('.card').find('.card__inner').find('.card__media').find('.card_variants__holder').find('.card_variant_content').find('fieldset').attr('data-position');
  if(position_effect == 'close' && isMobile == null)
  {
  $(this).find('.card-wrapper').find('.card').find('.card__inner').find('.card__media').find('.card_variants__holder').find('.card_variant_content').find('.legend').css('display','flex');
  }
  
}).on('mouseleave','.grid__item',  function(){
    let getStatusofProduct =  $(this).find('.card-wrapper').find('.card').find('.card__inner');
    let getBuyButtonID =  $(this).find('.card-wrapper').find('.card').find('.card__inner ').find('.card__media').find('.buy_button_section').attr("id"); 

    if(isMobile == null){
      if($(this).find('.card-wrapper').find('.card').find('.card__inner').hasClass('nohover')){
        //console.log('nohover active')
     }else{
      $(this).find('.card__media').find('.media').find('img').eq(0).fadeTo(200, 1); 
     }
  }


  if(getStatusofProduct.hasClass('onlycolor') || getStatusofProduct.hasClass('novariant'))
  {
      $('#'+getBuyButtonID+'').css('display','block');


      if(isMobile == null){
      anime({
          targets: '#'+getBuyButtonID+'',
          duration : 500,
          easing: 'easeOutQuart',
          bottom: '-64px',
          opacity: [1,0],
        
          
      }) 
    }
  }


    let position_effect = $(this).find('.card-wrapper').find('.card').find('.card__inner').find('.card__media').find('.card_variants__holder').find('.card_variant_content').find('fieldset').attr('data-position');
    if(position_effect == 'close' && isMobile == null){
    $(this).find('.card-wrapper').find('.card').find('.card__inner').find('.card__media').find('.card_variants__holder').find('.card_variant_content').find('.legend').css('display','none');
   }
});


$(document).on('click','.pmw_button_plus, .pmw_button_minus', async function (e){

  const isNegative = $(e.target).closest('.pmw_button_minus').is('.pmw_button_minus');
  const input = $(e.target).closest('.pmw__item_quantity_container').find('input');
  if (input.is('input')) {
    input[0][isNegative ? 'stepDown' : 'stepUp']()
    let getquantity = $('.pmw_holdQuantity').val();
   // console.log(getquantity);
    $('#add_to_cart').attr('data-quantity',getquantity);
  }

});


$(document).on('click','.pmw_button_plus_qa, .pmw_button_minus_qa', async function (e){

  const isNegative = $(e.target).closest('.pmw_button_minus_qa').is('.pmw_button_minus_qa');
  const input = $(e.target).closest('.pmw__item_quantity_container_qa').find('input');
  if (input.is('input')) {
    input[0][isNegative ? 'stepDown' : 'stepUp']()
    let getquantity = $('.pmw_holdQuantity_qa').val();
    //console.log(getquantity);
    $('.qa-button').attr('data-quantity',getquantity);
    //$('#add_to_cart').attr('data-quantity',getquantity);
  }

});

$(document).on('click','.pmw_button_plus_modal, .pmw_button_minus_modal', async function (e){

  const isNegative = $(e.target).closest('.pmw_button_minus_modal').is('.pmw_button_minus_modal');
  const input = $(e.target).closest('.pmw__item_quantity_container_modal').find('input');
  if (input.is('input')) {
    input[0][isNegative ? 'stepDown' : 'stepUp']()
    let getquantity = $('.pmw_holdQuantity').val();
   // console.log(getquantity);
    $('#add_to_cart').attr('data-quantity',getquantity);
  }

});


$(document).on('click','.size_select_pdp', async function (e){
       
       let getPosition = $(".pdp_size_dropdown").attr("data-position");
       if(getPosition == "close"){
        $(".pdp_size_dropdown").css("display","block");
        anime({
            targets : '.pdp_size_dropdown',
            duration : 500,
            easing: 'easeOutQuart',
            translateY: [-10 , 0],
            opacity: [0,1],
            complete: () => {
              $(".pdp_size_dropdown").attr("data-position","open");
          }
        })
       }else{
        anime({
          targets : '.pdp_size_dropdown',
          duration : 500,
          easing: 'easeOutQuart',
          translateY: [0 , -10],
          opacity: [1,0],
          complete: () => {
            $(".pdp_size_dropdown").attr("data-position","close");
            $(".pdp_size_dropdown").css("display","none");
        }
      })
       }
     

});

$(document).on('click','.size_select_pdp-feat', async function (e){
       
  let getPosition = $(".pdp_size_dropdown-feat").attr("data-position");
  if(getPosition == "close"){
   $(".pdp_size_dropdown-feat").css("display","block");
   anime({
       targets : '.pdp_size_dropdown-feat',
       duration : 500,
       easing: 'easeOutQuart',
       translateY: [-10 , 0],
       opacity: [0,1],
       complete: () => {
         $(".pdp_size_dropdown-feat").attr("data-position","open");
     }
   })
  }else{
   anime({
     targets : '.pdp_size_dropdown-feat',
     duration : 500,
     easing: 'easeOutQuart',
     translateY: [0 , -10],
     opacity: [1,0],
     complete: () => {
       $(".pdp_size_dropdown-feat").attr("data-position","close");
       $(".pdp_size_dropdown-feat").css("display","none");
   }
 })
  }


});


var announcementBar = $("#bambino_header_announcement_wrapper");
var content = $("#shopify-section-bambinomio-header");
var lastScrollTop = 0;
var isAnnouncementFixed = false;

$(window).scroll(function() {
  var currentScroll = $(window).scrollTop();

  if (currentScroll > 150 && !isAnnouncementFixed) {
    announcementBar.css({
      position: "fixed",
      top: "0",
      display: "none"
    }).fadeIn(200);
    content.css("paddingTop", announcementBar.outerHeight() + "px");
    isAnnouncementFixed = true;
  } else if (currentScroll <= 150 && isAnnouncementFixed) {
    announcementBar.fadeOut(function() {
      announcementBar.css({
        position: "relative",
        top: "",
        display: ""
      });
    });
    content.css("paddingTop", "0");
    isAnnouncementFixed = false;
  }

  lastScrollTop = currentScroll;
});


$(document).on('change','.size_variant_pdp', function (){


  let getProductID = $(this).attr("data-productid");
  $(this).parent().parent().parent().parent().parent().parent().parent().find(".pmw_buy_section").find("a").attr("data-id",getProductID);
  $('.variant__item_dpdp').removeClass('active');
  $(this).parent().parent().addClass('active');


  let getCalc = $(this).attr("data-discount") - $(this).attr("data-price");
  $('#discount_price_badge').html(Shopify.formatMoney(getCalc, theme.moneyFormat));

  //let getSubscription = $(this).attr('data-subscribe');

   $('.nPDP_size_variants').attr('data-current',$(this).val());  
   $('.pdp_size_dropdown').attr('data-current',$(this).val());


   if($('#percHolder')[0]){
         let getOfferValue = $(this).attr('data-offer');
         $('.qa-offer').find('p').html('SAVE '+getOfferValue);
   }




   if($('.nPDP-quick-add-wrapper')[0]){
        let getOfferValue = $(this).attr('data-offer');
        $('#percHolder').html(getOfferValue);
        let detectEmptyStatus = $('.qa-variant-name').find('span').eq(1).html();
        if(detectEmptyStatus == "" )
        {
          $('.qa-variant-name').find('span').eq(0).html($(this).val());
        }else{
          $('.qa-variant-name').find('span').eq(1).html($(this).val());
        }
       
        $('.qa-button').attr('data-id',getProductID);
   }

   if($('.bambino_selling_plan_container')[0]){
     let getSubsCompare = $(this).attr('data-selcp');
     let getSubsPrice = $(this).attr('data-selp');
     $('.bambino_selling_plan_container').find('.selling_plan_inputs').eq(0).find('.selling_plan_wrapper').find('.selling_plan_price_nPDP').find('span').html(Shopify.formatMoney(getSubsPrice, theme.moneyFormat));
     $('.bambino_selling_plan_container').find('.selling_plan_inputs').eq(1).find('.selling_plan_wrapper').find('.selling_plan_price_nPDP').find('small').html(Shopify.formatMoney(getSubsPrice, theme.moneyFormat));
     $('.bambino_selling_plan_container').find('.selling_plan_inputs').eq(0).find('.selling_plan_wrapper').find('.selling_plan_price_nPDP').find('small').html(Shopify.formatMoney(getSubsCompare, theme.moneyFormat));
     $('#__compare_price').html(Shopify.formatMoney(getSubsCompare, theme.moneyFormat));
   }



  $('#add_to_cart').prop( "disabled", false );
  $('#add_to_cart').removeClass('disable');
  //$('#add_to_cart').html('ADD TO CART');

  
  let getVariantSizeName = $(this).val()
  let arrayofSize = [];
  let arrayofAvailability = [];

    $( ".variant__item_dpdp" ).each(function( index ) {
    let getThisSize = $(this).attr('data-productsize');
          //console.log(getThisSize);
          if(getVariantSizeName == getThisSize) {
              let getID = $(this).attr('data-productmasterid');
              let getAvai = $(this).attr('data-status');
              arrayofSize.push(getID); 
              arrayofAvailability.push(getAvai);
          }
  });



  for(let i = 0; i < arrayofSize.length; i++){
         $('.color_variant_pdp').eq(i).attr('data-productid',arrayofSize[i]);
         $('.color_variant_pdp').eq(i).attr('data-available',arrayofAvailability[i]);
  }
  

     let getSizeVariantName = $(this).val();
    $('#variant_size_name').html(getSizeVariantName);
    $('.size_select_pdp').find('.size_displayer').html(getSizeVariantName);
    $('#variant_status').hide();
     

  let getPrice = $(this).data('price');
  let originalPrice =  $(this).data('discount');

  //console.log(originalPrice);

  if(originalPrice != "nodiscount"){
  $('#discount_price_').html(Shopify.formatMoney(originalPrice, theme.moneyFormat));
}else{
  $('#discount_price_').html('');
}
  $('#real_price_').html(Shopify.formatMoney(getPrice, theme.moneyFormat));

  let getStatus = $(this).parent().parent().parent().attr('data-status');
  if(getStatus != "soldout"){
    $('.pdp_buy').html(atcText);
  }

  let getMobileOption_f = $(this).val();
  let colorV = false;
  let sizeV = false;
  
  if( $('.nPDP-variants')[0]){
    colorV = true;   
  }

  if($('.nPDP-variants-size ')[0]){
    sizeV = true;   
  }

  if(colorV == true && sizeV == true){
      $('#mob_option_s').html(getMobileOption_f)
  }else{
     $('#mob_option_f').html(getMobileOption_f);
  }



});
/**/
$(document).on('change','.size_variant_pdp-feat', function (){


  let getProductID = $(this).attr("data-productid");
  let getValue = $(this).val();


  $(".fpc_buy_contianer").find("a").attr("data-id",getProductID);
  $("#size_select_feat_").html(getValue) 
  
  $('.variant__item_dpdp-feat').removeClass('active');
  $(this).parent().parent().addClass('active');


  $('.pdp_size_dropdown-feat').attr('data-current',$(this).val());

  $('.feat_buy_btn').prop( "disabled", false );
  $('.feat_buy_btn').removeClass('disable');
  $('.feat_buy_btn').html(atcText);

   let getVariantSizeName = $(this).val()
   let arrayofSize = [];
   let arrayofAvailability = [];

        $( ".variant__item_dpdp-feat" ).each(function( index ) {
    let getThisSize = $(this).attr('data-productsize');
          if(getVariantSizeName == getThisSize) {
              let getID = $(this).attr('data-productmasterid');
              let getAvai = $(this).attr('data-status');
              arrayofSize.push(getID); 
              arrayofAvailability.push(getAvai);
          }
  });

   for(let i = 0; i < arrayofSize.length; i++){
         $('.fpc_color_variant').eq(i).attr('data-productid',arrayofSize[i]);
         $('.fpc_color_variant').eq(i).attr('data-available',arrayofAvailability[i]);
  }

    let getSizeVariantName = $(this).val();
    $('#variant_size_name-feat').html(getSizeVariantName);
    $('.size_select_pdp-feat').find('.size_displayer').html(getSizeVariantName);
    $('#variant_status').hide();
      


  let getPrice = $(this).data('price');
  let originalPrice =  $(this).data('discount');

  //console.log(originalPrice);

  if(originalPrice != "nodiscount"){
  $('#fpc_original_price').html(Shopify.formatMoney(originalPrice, theme.moneyFormat));
}
  $('#fpc_price').html(Shopify.formatMoney(getPrice, theme.moneyFormat));


});
/**/

$(document).on('change','.color_variant_pdp', function (){

  let getProductID = $(this).attr("data-productid");

  let getCalc = $(this).attr("data-discount") - $(this).attr("data-price");

  let discountData = parseFloat($(this).attr("data-price"));
  let priceData = parseFloat($(this).attr("data-discount"));
  let percentCalc = 100-(Math.round(((discountData / priceData) * 100).toFixed(2)));
  let percentText = " " + percentCalc + "%";
  
  $('#discount_price_badge').html(Shopify.formatMoney(getCalc, theme.moneyFormat));
  $('#percHolder\\ price___').html(percentText);

  let getStatus = $(this).attr("data-available");
  if($('#percHolder')[0]){
  let get_variant_offer = $(this).attr('data-percent');
     if(get_variant_offer != '0%'){
       $('#percHolder').html(get_variant_offer);
     }
  }

  /*if(getStatus == 'soldout'){
      $('#variant_status').css('display','flex');
      $('#variant_status').html('SOLD OUT');
      $('#add_to_cart').prop( "disabled", true );
      $('#add_to_cart').addClass('disable');
      //$('#add_to_cart').html('SOLD OUT');
  }else{
      $('#variant_status').html('');
      $('#variant_status').hide();
      $('#add_to_cart').prop( "disabled", false );
      $('#add_to_cart').removeClass('disable');
      //$('#add_to_cart').html('ADD TO CART');
  }*/

   /*window.scroll({
                  top: $('body').offset().top,
                  behavior: "smooth"
              });*/

  $(this).parent().parent().parent().parent().parent().parent().parent().find(".pmw_buy_section").find("a").attr("data-id",getProductID);

  $('.pmw-media-container').find('li').remove();
  let getvariantName = $(this).val();
  let getProductName = $(this).attr("data-vname");
  let getProductSize = $(this).attr("data-size");
  let getPrice = $(this).data('price');
  let originalPrice =  $(this).data('discount');


  if(originalPrice != "nodiscount"){
  $('#discount_price_').html(Shopify.formatMoney(originalPrice, theme.moneyFormat));
}else{
  $('#discount_price_').html('');
}
  $('#real_price_').html(Shopify.formatMoney(getPrice, theme.moneyFormat));


  if(isMobile == null){
  let getVariantImages = $(this).data('fimage').split(',');
  let getVeriantImageslength = getVariantImages.length;
  let getMeme = $(this).data('meme');
  let getVideoData = $(this).data('video');
  let getVideoOrder = parseInt($(this).data('videoorder'));
  let videOrderFixed;
  let memeCol = 3;
  let memeColFixed = 5;
  let getVideo = $(this).data('video');


  if(getMeme != 'nomeme'){
      videOrderFixed = getVideoOrder -1;
      memeCol = 3
      memeColFixed = 4;
  }else{
      videOrderFixed = getVideoOrder-1;
      memeCol = 2
      memeColFixed = 5;

  }


  for (let i = 0; i < getVeriantImageslength; i++) {
       let getImagesVariable = getVariantImages[i];
         if(i == videOrderFixed && getVideoData != 'novideo')
         {
          $('.pmw-media-container').append(`<li class="media__items_holder b2-column-layout carousel-cell"><div class="product_video"><iframe src="https://player.vimeo.com/video/${getVideo}?h=e7abf97668&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1&amp;loop=1&amp;muted=1&amp;background=1" loop="" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="C1O0i1GaIZS"></iframe></div></li>`);  
          $('.pmw-media-container').append(`<li class="media__items_holder carousel-cell b${i > 1 && i < memeColFixed ? memeCol : '2'}-column-layout"><img src="${getImagesVariable}&amp;width=3840" alt="" srcset="${getImagesVariable}&amp;width=375 375w, ${getImagesVariable}&amp;width=550 550w, ${getImagesVariable}&amp;width=750 750w, ${getImagesVariable}&amp;width=1100 1100w, ${getImagesVariable}&amp;width=1500 1500w, ${getImagesVariable}&amp;width=1780 1780w, ${getImagesVariable}&amp;width=2000 2000w, ${getImagesVariable}&amp;width=3000 3000w, ${getImagesVariable}&amp;width=3840 3840w" height="372" loading="lazy" sizes="100vw"></li>`);
         }
         
         else{
          if(getMeme != 'nomeme' && i > 2 && i < 4){
            $('.pmw-media-container').append(`<li class="media__items_holder carousel-cell b3-column-layout column-rotate "><img src="${getMeme}&amp;width=3840" alt="" srcset="${getMeme}&amp;width=375 375w, ${getMeme}&amp;width=550 550w, ${getMeme}&amp;width=750 750w, ${getMeme}&amp;width=1100 1100w, ${getMeme}&amp;width=1500 1500w, ${getMeme}&amp;width=1780 1780w, ${getMeme}&amp;width=2000 2000w, ${getMeme}&amp;width=3000 3000w, ${getMeme}&amp;width=3840 3840w" height="372" loading="lazy" sizes="100vw"></li>`); 
            $('.pmw-media-container').append(`<li class="media__items_holder carousel-cell b3-column-layout"><img src="${getImagesVariable}&amp;width=3840" alt="" srcset="${getImagesVariable}&amp;width=375 375w, ${getImagesVariable}&amp;width=550 550w, ${getImagesVariable}&amp;width=750 750w, ${getImagesVariable}&amp;width=1100 1100w, ${getImagesVariable}&amp;width=1500 1500w, ${getImagesVariable}&amp;width=1780 1780w, ${getImagesVariable}&amp;width=2000 2000w, ${getImagesVariable}&amp;width=3000 3000w, ${getImagesVariable}&amp;width=3840 3840w" height="372" loading="lazy" sizes="100vw"></li>`);
            }
          else $('.pmw-media-container').append(`<li class="media__items_holder carousel-cell b${i > 1 && i < memeColFixed ? memeCol : '2'}-column-layout"><img src="${getImagesVariable}&amp;width=3840" alt="" srcset="${getImagesVariable}&amp;width=375 375w, ${getImagesVariable}&amp;width=550 550w, ${getImagesVariable}&amp;width=750 750w, ${getImagesVariable}&amp;width=1100 1100w, ${getImagesVariable}&amp;width=1500 1500w, ${getImagesVariable}&amp;width=1780 1780w, ${getImagesVariable}&amp;width=2000 2000w, ${getImagesVariable}&amp;width=3000 3000w, ${getImagesVariable}&amp;width=3840 3840w" height="372" loading="lazy" sizes="100vw"></li>`);
          }
       }

  }


  let lengthofDropDown = $(".pdp_size_dropdown").find("li").length;
  let lengthofSizes = $(".nPDP_size_variants").find("li").length;
  let getCurrent = $('.pdp_size_dropdown').attr('data-current');
  let getCurrentnPDP = $('.nPDP_size_variants').attr('data-current');
  let getColor = $(this).attr('data-vname');
  let getCurrentSize = $('.nPDP_size_variants').attr("data-current");

  
  $( ".nPDP-size" ).each(function( index ) {
    
    if($(this).attr('data-productcolor') == getColor && $(this).attr('data-productsize') == getCurrentSize ){
       //console.log("match");
        $('#add_to_cart').attr('data-id', $(this).attr('data-productmasterid'));
    }
      
});
 

  if($('.pdp_size_dropdown')[0]){
  for (let i = 0; i < lengthofDropDown; i++) {
    let getAttr = $(".pdp_size_dropdown").find("li").eq(i).attr('data-productcolor');
    let getSize = $(".pdp_size_dropdown").find("li").eq(i).attr('data-productsize');

      if(getProductName == getAttr && getCurrent == getSize){
    
      if($(".pdp_size_dropdown").find("li").eq(i).attr('data-status') == 'available'){
          $('#variant_status').hide();
          $('#variant_status').html('')
          $('#add_to_cart').prop( "disabled", false );
          $('#add_to_cart').removeClass('disable');
          $('#add_to_cart').html(atcText);
      }else{
          $('#variant_status').show();
          $('#add_to_cart').prop( "disabled", true );
          $('#add_to_cart').addClass('disable');
          $('#add_to_cart').html(soldText);
          $('#variant_status').html(soldText)

      }
    }
    
   
    if(getProductName == getAttr){
      $(".pdp_size_dropdown").find("li").eq(i).removeClass('displayno_pdp');
    }
    else{
      $(".pdp_size_dropdown").find("li").eq(i).addClass('displayno_pdp');
    }
}

}

if($('.nPDP_size_variants')[0]){
  for (let i = 0; i < lengthofSizes; i++) {
    let getAttr = $(".nPDP_size_variants").find("li").eq(i).attr('data-productcolor');
    let getSize = $(".nPDP_size_variants").find("li").eq(i).attr('data-productsize');

      if(getProductName == getAttr && getCurrentnPDP == getSize){
    
      if($(".nPDP_size_variants").find("li").eq(i).attr('data-status') == 'available'){
          $('#variant_status').hide();
          $('#variant_status').html('')
          $('#add_to_cart').prop( "disabled", false );
          $('#add_to_cart').removeClass('disable');
          $('#add_to_cart').html(atcText);
      }else{
          $('#variant_status').show();
          $('#add_to_cart').prop( "disabled", true );
          $('#add_to_cart').addClass('disable');
          $('#add_to_cart').html(soldText);
          $('#variant_status').html(soldText)

      }
    }
    
   
    if(getProductName == getAttr){
      $(".nPDP_size_variants").find("li").eq(i).removeClass('displayno_pdp');
      $(".nPDP_size_variants").find("li").eq(i).removeClass('active');
      if(getCurrentnPDP == $(".nPDP_size_variants").find("li").eq(i).attr('data-productsize')){
        $(".nPDP_size_variants").find("li").eq(i).addClass('active');
      }
    }
    else{
      $(".nPDP_size_variants").find("li").eq(i).addClass('displayno_pdp');
    }
}
}

$('#variant_color_name').html(getvariantName);

let getVisibility = $(this).attr('data-percent');
if(getVisibility != '0%'){
     $('.pmwp-discount-nPDP-text').removeClass('hide_badge');
}else{
     $('.pmwp-discount-nPDP-text').addClass('hide_badge');
}


if ($(".nPDP-quick-add-container")[0]){
  
     let getBarColor = $(this).val();
     let getBarSize =  $(this).attr('data-size');
     let getColorImage = $(this).parent().find('label').find('img').attr('src');
     let getPid = $(this).attr('data-productid');
     let getPrice = $(this).attr('data-price');
     let getCompare_at_price = $(this).attr('data-discount');
     let getPercent = $(this).attr('data-percent');

     let data = {
        'product_id': getPid,
        'product_color': getBarColor,
        'product_size': getBarSize,
        'product_price': getPrice,
        'compare_at_price': getCompare_at_price,
        'percent': getPercent,
        'product_image': getColorImage
     }

    // console.log(data);

     $('.qa-price').find('span').html(Shopify.formatMoney(data.product_price, theme.moneyFormat));
     if(data.compare_at_price != 'nodiscount'){
     $('.qa-price').find('small').html(Shopify.formatMoney(data.compare_at_price, theme.moneyFormat));
    }
     if(data.percent != '0%'){
     $('.qa-offer').find('p').html('SAVE '+data.percent);
     $('.qa-offer').find('p').show();
     }else{
      $('.qa-offer').find('p').hide(); 
     }
     $('.qa-variant-name').find('span').eq(0).html(data.product_color);
     $('.qa-variant-name').find('span').eq(1).html(data.product_size);
     $('.qa-variant-img').find('img').attr('src', data.product_image);
     $('.qa-button').attr('data-id',data.product_id);

     //mobile
      ///$('.mobile_variant').find('span').eq(0).html(data.product_color);
      //$('.mobile_variant').find('span').eq(1).html(data.product_size);

      $('#mob_option_f').html(data.product_color);

    
}


});


$(document).on('touchstart click','.wiitb_description_container', function (){
    
    let getID = $(this).attr("id");
    let getPosition = $(this).attr("data-position");

    if(getPosition == "close"){
      $(this).find(".wiitb_expand_button").find(".wiitb_arrow").css({ "transform": "rotate(45deg)", "top": "-2px" });
      $(this).find(".more_info").html("less info");
      anime({
        targets: '#'+getID+'',
        duration : 500,
        easing: 'easeOutQuart',
        bottom: ['0px'],
        complete: () => {
          $(this).attr("data-position","open");
         
        
      }
      })
    }else{
      $(this).find(".wiitb_expand_button").find(".wiitb_arrow").css({ "transform": "rotate(-135deg)", "top": "1px" });
      $(this).find(".more_info").html("more info");
      anime({
        targets: '#'+getID+'',
        duration : 500,
        easing: 'easeOutQuart',
        bottom: ['-171px'],
        complete: () => {
          $(this).attr("data-position","close");
         
    
      }
      })
    }
    

});

$(document).on('mouseenter','.btclc-item', function (event) {
    /* let getID = $(this).attr("id");
     let getPosition = parseInt($(this).attr("data-rotate"));
     let getContainerPosition = $(this).attr("data-position");
     if(getContainerPosition == "close"){
      anime({
        targets: '#'+getID+'',
        duration : 500,
        easing: 'easeOutQuart',
        rotate: [''+getPosition+'deg','0deg']
       
      })
     }*/
    


}).on('mouseleave','.btclc-item',  function(){
  /*let getID = $(this).attr("id");
  let getPosition = parseInt($(this).attr("data-rotate"));
  let getContainerPosition = $(this).attr("data-position");
  if(getContainerPosition == "close"){
  anime({
   targets: '#'+getID+'',
   duration : 500,
   easing: 'easeOutQuart',
   rotate: ['0deg',''+getPosition+'deg']
  
 })
}*/

});




let playpauseControl = 0;
$(document).on('click','.product_pause_play', function (){
  let getVideoID = $(this).parent().attr('id');    
  var getVimeoID = $(this).parent().attr('data-vimeoid');
  let playerx = new Vimeo.Player(getVideoID,getVimeoID);
  if(playpauseControl == 0) {
    playerx.pause().then(function(paused) {
      playpauseControl = 1;
      $('#product_video_controller').attr('src','https://cdn.shopify.com/s/files/1/0665/2153/0602/files/play_button_product.svg?v=1682355202');
    });
}else{
   playerx.play().then(function(play) {
    playpauseControl = 0;
    $('#product_video_controller').attr('src','https://cdn.shopify.com/s/files/1/0665/2153/0602/files/pause_button_product.svg?v=1682355201');
   });
}
});

$(document).on('click','.btlc-expander', function (){

if($(this).hasClass('video_inside')){
let getVideoID = $(this).parent().parent().find('.btlc_real_content_container').find('.media_container_btcl').find('.bambino-video').attr('id');    
var getVimeoID = $(this).parent().parent().find('.btlc_real_content_container').find('.media_container_btcl').find('.bambino-video').attr('data-vimeoid');
//console.log(getVimeoID);

//vimeoVideo(getVimeoID,getVideoID,'720p',true,true,true,false);
  }  
      let thisisit = $(this);
      let getPosition = $(this).parent().parent().parent().attr("data-position");
      let getOrder = $(this).parent().parent().parent().attr("data-order");
      let getAnimID = $(this).parent().parent().parent().attr("id");
      let getContentID = $(this).parent().parent().find(".btlc_real_content_container").attr("id");

    // $('.btlc-expander').parent().parent().parent().parent().find('li').animate({opacity: 0}, 500, function(){ $(this).css("display","none");  $('.items-3col-'+getOrder+'').css({ "display" : "flex" }); });
     //$('.items-3col-'+getOrder+'').css({ "opacity" : 1 });
    
   
     
     $('.btclc-item').addClass('notfree');
     $(this).parent().parent().parent().removeClass("notfree");


     
   if(getPosition == "close" && $('.btclc-item').hasClass('notfree')){
           
           let calculate = (getOrder - 1) * 33
           $('.btclc-item').css({ "opacity" : 0 });
           $('.items-3col-'+getOrder+'').css({ "opacity" : 1 });
          
           if(isMobile == null){

            anime({
              targets: '.items-3col-'+getOrder+'',
              left: [calculate+'%', '0%'],
              width: ['32%','100%'],
              rotate: '0deg',
              easing: 'easeOutQuart',
              duration: 500,
              opacity: 1,
            })

            anime({
              targets: '.btlc',
              easing: 'easeOutQuart',
              duration: 300,
              delay: 100,
              opacity: 0,
              complete: () => {
                $( '.btlc').css("display","none");
                $( '#'+getContentID+'').css("display","flex");
                thisisit.parent().parent().parent().attr('data-position', 'open');
                anime({
                  targets: '#'+getContentID+'',
                  duration : 300,
                  easing: 'easeOutQuart',
                  opacity: [0,1]
                });
              }
            })

   /*
            let calculate = (getOrder - 1) * 101.5;
          
           
            anime({
              targets: '.items-3col-'+getOrder+'',
              translateX: [calculate+'%', '0%'],
              duration:500, 
              opacity:1,
              easing: 'easeOutQuart',
              complete: () => {
                anime({
                  targets: '.items-3col-'+getOrder+'',
                  width: ['33%', '100%'],
                  duration:500, 
                  delay:300,
                  easing: 'easeOutQuart'
                });
                anime({
                  targets: '.btlc',
                  duration:300, 
                  easing: 'easeOutQuart',
                  opacity:[1,0],
                  complete: () => {
                    $( '#'+getContentID+'').css("display","flex");
                    $( '.btlc').css("display","none");
                    thisisit.parent().parent().parent().parent().find('li').attr('data-position', 'open');
                    anime({
                      targets: '#'+getContentID+'',
                      duration : 300,
                      easing: 'easeOutQuart',
                      opacity: [0,1]
                    });
                  }
                });
              }
            });*/

   }else{
    //$('.btlc').css({"opacity":1, "display": "block" });
    $('.btclc-item').css({ "opacity" : 1 });
    $('.items-3col-'+getOrder+'').find('.btlc-item-content').find('.btlc').css("display","none");
    $('html, body').animate({
      scrollTop: $('.items-3col-'+getOrder+'').offset().top
  }, 300);
  /*anime({
    targets: '.btclc-item',
    width: ['100%'],
    easing: 'easeOutQuart',
    duration:200
  })*/
    anime({
      targets: '.items-3col-'+getOrder+'',
      //left: [calculate+'%', '0%'],
      //width: ['100%','100%'],
      rotate: '0deg',
      easing: 'easeOutQuart',
      duration: 0,
      opacity: 1,
      complete: () => {
       
        
        //$('.btlc').css("display","none");
        //$('.btlc-item').css("width","100%");
        $('#'+getContentID+'').css("display","flex");
        thisisit.parent().parent().parent().attr('data-position', 'open');
        anime({
          targets: '#'+getContentID+'',
          duration : 400,
          easing: 'easeOutQuart',
          opacity: [0,1]
        });
      }
    })
   }
  }
      
 
   
});

$(document).on('click','.btlc-expander_close', function (){
  let fixedSize; 
  let getPosition = $(this).parent().parent().parent().attr("data-position");
  let getAnimID = $(this).parent().parent().parent().attr("id");
  let getOrder = $(this).parent().parent().parent().attr("data-order");
  let calculate = (getOrder - 1) * 33

  let orderFixed = 0;
  let rotateMe = 0;
           if(getOrder == 2){
              orderFixed = 34;
              rotateMe = -1;
           }if(getOrder == 3){
              orderFixed = 67.9;
           }


  if(getPosition == "open"){

    if(isMobile == null){

      anime({
        targets: '.btlc_real_content_container',
        duration : 500,
        easing: 'easeOutQuart',
        opacity: [1,0],
        complete: () => {
          $('.btlc_real_content_container').css("display","none");
          anime({
            targets: '.items-3col-'+getOrder+'',
            left: ['0%', orderFixed+'%'],
            width: ['100%','32%'],
            rotate: ''+rotateMe+'deg',
            easing: 'easeOutQuart',
            duration: 500,
            opacity: 1,
            complete: () => {
              $( '.btlc').css("display","block");
              anime({
                targets: '.btlc',
                easing: 'easeOutQuart',
                duration: 300,
                delay: 100,
                opacity: [0,1],
                complete : () => {
                  $('.btclc-item').css({ "opacity" : 1 });
                  $('.btclc-item').attr('data-position','close');
                }
              });
            }
          })

         



        }
      });


    /*anime({
      targets: '.btlc_real_content_container',
      duration : 500,
      easing: 'easeOutQuart',
      opacity: [1,0],
      complete: () => {
        $('.btlc_real_content_container').css("display","none");
        anime({
          targets: '.items-3col-'+getOrder+'',
          width: ['100%', '33%'],
          duration: 500, 
          easing: 'easeOutQuart',
          complete: () => {
            $('.btlc').css("display","block");
            anime({
              targets: '.btlc',
              duration:300, 
              easing: 'easeOutQuart',
              opacity:[0,1],
              complete: () => {
                anime({
                  targets: '.items-3col-'+getOrder+'',
                  translateX: ['0%',calculate+'%'],
                  duration:500, 
                  easing: 'easeOutQuart',
                  complete: () => {
                    $('.btclc-item').attr("style","");
                    $('.btlc_real_content_container').attr('style','');
                    $('.btlc').attr('style','');
                    $('.btclc-item').attr('data-position','close');
                  }
            })
              }
            });
          
          }
        });

        
       
  }
});*/

}else{
  $('html, body').animate({
    scrollTop: $('.items-3col-1').offset().top
}, 300);
  anime({
    targets: '.btlc_real_content_container',
    duration : 500,
    easing: 'easeOutQuart',
    opacity: [1,0],
    complete: () => {
      $('.btlc_real_content_container').css("display","none"); 
      $('.btlc_real_content_container').attr('style','');
      if(getOrder != 3){
           fixedSize = '100%';
      }else{
           fixedSize = '100%'; 
      }
      anime({
        targets: '.items-3col-'+getOrder+'',
        width: ['100%', fixedSize],
        duration: 500, 
        easing: 'easeOutQuart',
        complete: () => {
          $('.btlc').css("display","block");
          anime({
            targets: '.btlc',
            duration:300, 
            easing: 'easeOutQuart',
            opacity:[0,1],
            complete: () => {
              $('.btclc-item').attr("style","");
              $('.btlc').attr('style','');
              $('.btclc-item').attr('data-position','close');
            }
          });
        
        }
      });
    
      
     
}
});
}


 /* anime({
    targets: '.forflex',
    duration : 500,
    easing: 'easeOutQuart',
    opacity: [1,0]
 });
 anime({
  targets: '.btlc_real_content_container',
  duration : 500,
  easing: 'easeOutQuart',
  opacity: [1,0],
  complete: () => {
    $('.btlc_real_content_container').css("display","none");
    anime({
      targets : '#'+getAnimID+'',
      duration : 500,
      easing: 'easeOutQuart',
      width: '33.3%',
      complete: () => {
        $(".btlc").css("display","block");
        $('.btlc-expander').parent().parent().parent().css("display","flex");
        $(this).parent().parent().parent().attr("data-position","close");
        anime({
          targets: '.notfree',
          duration : 500,
          delay: 400,
          easing: 'easeOutQuart',
          opacity: [0,1],
          complete: () => {
            $(".btlc").css("display","block");
          }
       });
      }
     });
}
});*/
  }
});


$(document).on('touchstart click','.product_result', function (){ 
     
      
      $('#_product').show();
      $('#_pages').hide();
      $('#_article').hide();
      $(this).addClass('active');
      $('.pages_articles_result').removeClass('active');
});


$(document).on('click','.pages_articles_result', function (){ 
     let getPageLength = $('.page__').length;
     let getArticleLength = $('.grid__item_article').length;

    // console.log(getPageLength+" / "+getArticleLength);

     $(this).addClass('active');
      $('.product_result').removeClass('active');

     $('#_product').hide();
     if(getPageLength > 0){
      $('#_pages').show();
     }
     if(getArticleLength > 0){
     $('#_article').show();
     }
});

$(document).on('touchstart click','#add_new_address__', function (){ 
  $(".modal_overlay").css("display","block");
  $(".modal_address").css("display","flex");
  $(".modal_address").attr('data-position','open');
  anime({
    targets: '.modal_address',
    duration: 500,
    opacity:[0,1],
    easing: 'easeOutQuart',
  })

  anime({
     targets:'.modal_overlay',
     duration: 1000,
     opacity:[0,1],
     easing: 'easeOutQuart',
  })
});

$(document).on('touchstart click','#add_new___address', function (){ 
  anime({
    targets: '.modal_address',
    duration: 300,
    opacity:[1,0],
    easing: 'easeOutQuart',
    complete: () => {
      $(".modal_address").css("display","none");
  }
  })

  anime({
     targets:'.modal_overlay',
     duration: 300,
     opacity:[1,0],
     easing: 'easeOutQuart',
     complete: () => {
         $(".modal_overlay").css("display","none");
     }
  })
  $(".modal_address").attr("data-position","close");
});


$(document).on('touchstart click','._edit__adress', function (){ 
     $(".modal_overlay").css("display","block");
     $(".modal_address_editable").css("display","flex");
     $(".modal_address_editable").attr('data-position','open');
     let getEditFormID = $(this).attr("id");
     let getEdit = getEditFormID.split("_");
     let realID = "#EditAddress_"+getEdit[1];
     $(realID).css('display','block');
     anime({
         targets : realID,
         duration: 300,
         opacity:[0,1],
         easing: 'easeOutQuart'
     })

     anime({
      targets:'.modal_overlay',
      duration: 1000,
      opacity:[0,1],
      easing: 'easeOutQuart',
   })

   anime({
    targets: '.modal_address_editable',
    duration: 500,
    opacity:[0,1],
    easing: 'easeOutQuart',
  })

   

});

$(document).on('touchstart click','#edit___address', function (){
      
  anime({
    targets: '.editable_addresses',
    duration: 300,
    opacity:[1,0],
    easing: 'easeOutQuart',
    complete: () => {
      $(".editable_addresses").css("display","none");
  }
  })

  anime({
    targets: '.modal_address_editable',
    duration: 300,
    opacity:[1,0],
    easing: 'easeOutQuart',
    complete: () => {
      $(".modal_address_editable").css("display","none");
  }
  })


  anime({
     targets:'.modal_overlay',
     duration: 300,
     opacity:[1,0],
     easing: 'easeOutQuart',
     complete: () => {
         $(".modal_overlay").css("display","none");
     }
  })
  $(".modal_address_editable").attr("data-position","close");

 });

 $('#address_form_new').on('submit', function(e) {
      let firstname = $('#AddressFirstNameNew').val();
      let lastname = $('#AddressLastNameNew').val();
      let address1 = $('#AddressAddress1New').val();
      let country = $('#AddressCountryNew').val();
      let zipcode = $('#AddressZipNew').val();

      if(firstname == null || firstname == ""){
           $('#AddressFirstNameNew').parent().find('span').remove();
           $('#AddressFirstNameNew').parent().append('<span>*Enter your first name</span>');
           return false;
      }else{
        $('#AddressFirstNameNew').parent().find('span').remove();
      }

      if(lastname == null || lastname == ""){
        $('#AddressLastNameNew').parent().find('span').remove();
        $('#AddressLastNameNew').parent().append('<span>*Enter your last name</span>');
        return false;
      }else{
        $('#AddressLastNameNew').parent().find('span').remove();
      }

      if(address1 == null || address1 == ""){
        $('#AddressAddress1New').parent().find('span').remove();
        $('#AddressAddress1New').parent().append('<span>*Enter your address</span>');
        return false;
     }else{
      $('#AddressAddress1New').parent().find('span').remove();
     }
 
     if(country == null || country == "---"){
      $('#AddressCountryNew').parent().find('span').remove();
      $('#AddressCountryNew').parent().append('<span>*Select your country</span>');
      return false;
     }else{
      $('#AddressCountryNew').parent().find('span').remove();
     }

     if(zipcode == null || zipcode == ""){
      $('#AddressZipNew').parent().find('span').remove();
      $('#AddressZipNew').parent().append('<span>*Enter your zip code</span>');
      return false;
    }else{
      $('#AddressZipNew').parent().find('span').remove();
    }

  });

   $('.bambino_editable_form').on('submit', function(e) {

    let getFormId = $(this).attr('id');
    let findID = getFormId.split('_');
    let getRealID = findID[2];

    let firstname = $('#AddressFirstName_'+getRealID+'').val();
    let lastname = $('#AddressLastName_'+getRealID+'').val();
    let address1 = $('#AddressAddress1_'+getRealID+'').val();
    let country = $('#AddressCountry_'+getRealID+'').val();
    let zipcode = $('#AddressZip_'+getRealID+'').val();

    if(firstname == null || firstname == ""){
      $('#AddressFirstName_'+getRealID+'').parent().find('span').remove();
      $('#AddressFirstName_'+getRealID+'').parent().append('<span>*Enter your first name</span>');
      return false;
 }else{
   $('#AddressFirstName_'+getRealID+'').parent().find('span').remove();
 }

 if(lastname == null || lastname == ""){
   $('#AddressLastName_'+getRealID+'').parent().find('span').remove();
   $('#AddressLastName_'+getRealID+'').parent().append('<span>*Enter your last name</span>');
   return false;
 }else{
   $('#AddressLastName_'+getRealID+'').parent().find('span').remove();
 }

 if(address1 == null || address1 == ""){
   $('#AddressAddress1_'+getRealID+'').parent().find('span').remove();
   $('#AddressAddress1_'+getRealID+'').parent().append('<span>*Enter your address</span>');
   return false;
}else{
 $('#AddressAddress1_'+getRealID+'').parent().find('span').remove();
}

if(country == null || country == "---"){
 $('#AddressCountry_'+getRealID+'').parent().find('span').remove();
 $('#AddressCountry_'+getRealID+'').parent().append('<span>*Select your country</span>');
 return false;
}else{
 $('#AddressCountry_'+getRealID+'').parent().find('span').remove();
}

if(zipcode == null || zipcode == ""){
 $('#AddressZip_'+getRealID+'').parent().find('span').remove();
 $('#AddressZip_'+getRealID+'').parent().append('<span>*Enter your zip code</span>');
 return false;
}else{
 $('#AddressZip_'+getRealID+'').parent().find('span').remove();
}


   });

  let getSizeItem = $('.nav_item_faq').length;

  if(getSizeItem == 2){
    $('.nav_item_faq').eq(1).find('.bfbc-item').find('.bfbc-item__').find('.line_faq').hide(); 
    $('.nav_item_faq').eq(1).find('.bfbc-item').find('.bfbc-item__').find('.line_faq_left').hide(); 
  }else if(getSizeItem == 3){
    $('.nav_item_faq').eq(1).find('.bfbc-item').find('.bfbc-item__').find('.line_faq').hide(); 
    $('.nav_item_faq').eq(1).find('.bfbc-item').find('.bfbc-item__').find('.line_faq_left').hide(); 
  }

  $(document).on('touchstart click','.nav_item_faq', function (){ 

       if($(this).hasClass('disabled')){
        // console.log('Disabled')
       }else{

       let getOrder = $(this).data('order');
       let getType = $(this).attr('data-type');
       //console.log(getType);
        if(getOrder == 1){
          if(getSizeItem != 2 && getSizeItem != 3){  
        $('.nav_item_faq').eq(1).find('.bfbc-item').find('.bfbc-item__').find('.line_faq').show(); 
        $('.nav_item_faq').eq(2).find('.bfbc-item').find('.bfbc-item__').find('.line_faq').show(); 
          }else if(getSizeItem == 3){
            $('.nav_item_faq').eq(2).find('.bfbc-item').find('.bfbc-item__').find('.line_faq').hide(); 
            $('.nav_item_faq').eq(2).find('.bfbc-item').find('.bfbc-item__').find('.line_faq_left').show(); 
          }
        }else if(getOrder == 2){
          if(getSizeItem != 2 && getSizeItem != 3){  
        $('.nav_item_faq').eq(0).find('.bfbc-item').find('.bfbc-item__').find('.line_faq').hide(); 
        $('.nav_item_faq').eq(2).find('.bfbc-item').find('.bfbc-item__').find('.line_faq').show(); 
        $('.nav_item_faq').eq(3).find('.bfbc-item').find('.bfbc-item__').find('.line_faq_left').hide(); 
          }else if(getSizeItem == 3){
            $('.nav_item_faq').eq(0).find('.bfbc-item').find('.bfbc-item__').find('.line_faq').hide(); 
            $('.nav_item_faq').eq(2).find('.bfbc-item').find('.bfbc-item__').find('.line_faq').hide(); 
            $('.nav_item_faq').eq(2).find('.bfbc-item').find('.bfbc-item__').find('.line_faq_left').hide(); 
            $('.nav_item_faq').eq(3).find('.bfbc-item').find('.bfbc-item__').find('.line_faq_left').hide(); 
          }

        }else if(getOrder == 3){
          $(this).find('.bfbc-item').find('.bfbc-item__').find('.line_faq').hide(); 
          $(this).find('.bfbc-item').find('.bfbc-item__').find('.line_faq_left').hide(); 
          $('.nav_item_faq').eq(0).find('.bfbc-item').find('.bfbc-item__').find('.line_faq').show();  
          $('.nav_item_faq').eq(1).find('.bfbc-item').find('.bfbc-item__').find('.line_faq').hide(); 
          $('.nav_item_faq').eq(3).find('.bfbc-item').find('.bfbc-item__').find('.line_faq_left').hide();  
        }else if(getOrder == 4){
          $('.nav_item_faq').eq(1).find('.bfbc-item').find('.bfbc-item__').find('.line_faq').show();
          $('.nav_item_faq').eq(2).find('.bfbc-item').find('.bfbc-item__').find('.line_faq').hide();  
          $('.nav_item_faq').eq(0).find('.bfbc-item').find('.bfbc-item__').find('.line_faq').show(); 
       }
       $('.bambino-faq-content-container').css({ "visibility": "hidden", "position": "absolute" , "top": "0px", "z-index" : "-1" });
       $('.'+getType+'').css({ "visibility": "visible", "position": "relative" , "top": "unset", "z-index" : "unset" });
       $('.bfbc-item__').removeClass('active');
       $('.navigation_prop').removeClass('active');
       $('.bfbc-icon-circle').removeClass('active');
       $(this).find('.bfbc-item').find('.navigation_prop').addClass('active');
       $(this).find('.bfbc-item').find('.bfbc-item__').find('.bfbc-icon-wrapper').find('.bfbc-icon-circle ').addClass('active');
       $(this).find('.bfbc-item').find('.bfbc-item__').addClass('active');
       }
  });




  $(document).on('click','.bfcc_action_', function (){ 

        let getID = $(this).attr('data-id');
        let getPosition = $('#bfcc_cont_'+getID+'').attr('data-position');
        let thisis = $(this);
        if(getPosition == 'close'){
          $('#bfcc_cont_'+getID+'').slideDown("normal", function() {
            $('#bfcc_cont_'+getID+'').attr('data-position','open');
            thisis.find('.bfcc-position').html('-');
          });  
          thisis.parent().addClass('active');
          thisis.parent().parent().addClass('active');
         
        }else{
          let thisis = $(this);
          $('#bfcc_cont_'+getID+'').slideUp("normal", function() {
            $('#bfcc_cont_'+getID+'').attr('data-position','close');
            thisis.find('.bfcc-position').html('+');
            thisis.parent().removeClass('active');
            thisis.parent().parent().removeClass('active');
          });  
         
        }
       


  });
 








   let lengthOfreusable;
   let lengthOfgetstarted;
   let lengthOfourProducts;

   let lengthOfreusable_title;
   let lengthOfgetstarted_title;
   let lengthOfourProducts_title;

   let lengthOUsing;
   let seperateIt;
   let getLength;

  function search() {
    let searched = "";
    $('.bfcc-item-master').removeClass('hideThisContent');
    $('.bfcc-item-master').removeClass('hideThisTitle');
    $('.bfcc-item-master').removeClass('showThisContent');
    $('.bfcc-item-master').removeClass('showThisTitle');
    $('.nav_item_faq').removeClass('disabled');
    $("mark").replaceWith(function() { return this.innerHTML; });
    $(".bfbc_search_result").css("display","flex");
    searched = document.getElementById("search").value;
    seperateIt = searched.split(" ");
    getLength = seperateIt.length;
    if (searched !== "" && searched.length >= 3) {
      $( ".sTitle" ).each(function( index ) {
        for (let i = 0; i < getLength; i++) {
        let text = $(this).html();
        let re = new RegExp(seperateIt[i].trim(),"gi"); // search for all instances
        let newText = text.replace(re, `<mark>${seperateIt[i]}</mark>`);
        $(this).html(newText);
        }
        
        
        let getMarkLength = $(this).find('mark').length;
        if(getMarkLength <= 0 ){
          $(this).parent().parent().parent().parent().addClass('hideThisTitle');
          $(this).parent().addClass("noresult");
         }else{
          $(this).parent().parent().parent().parent().addClass('showThisTitle');
         }

      });
   
      $( ".sContent" ).each(function( index ) {
        for (let i = 0; i < getLength; i++) {
        let text = $(this).html();
        let re = new RegExp(seperateIt[i].trim(),"gi"); // search for all instances
        let newText = text.replace(re, `<mark>${seperateIt[i]}</mark>`);
        $(this).html(newText);
        }
        let getMarkLength = $(this).find('p').find('mark').length;
       // console.log(getMarkLength);
        if(getMarkLength <= 0 ){
          $(this).parent().parent().parent().addClass('hideThisContent');
          $(this).parent().parent().find('.bfcc-item-header').find('a').addClass("noresult");
         }else{
          $(this).parent().parent().parent().addClass('showThisContent');
         }
      });

      
    }

   lengthOfreusable = $('._reusable').find('.showThisContent').length;
   lengthOfgetstarted = $('._getstarted').find('.showThisContent').length;
   lengthOfourProducts = $('._ourproducts').find('.showThisContent').length;
   lengthOUsing = $('._using').find('.showThisContent').length;


   lengthOfreusable_title = $('._reusable').find('ul').find('.showThisTitle').length;
   lengthOfgetstarted_title = $('._getstarted').find('ul').find('.showThisTitle').length;
   lengthOfourProducts_title = $('._ourproducts').find('ul').find('.showThisTitle').length;
   lengthOUsing_title = $('._using').find('ul').find('.showThisTitle').length;

    
   totalReusable = lengthOfreusable + lengthOfreusable_title;
   totalgetStarted = lengthOfgetstarted + lengthOfgetstarted_title;
   totalProducts = lengthOfourProducts + lengthOfourProducts_title;
   totalUsing = lengthOUsing + lengthOUsing_title;

   //console.log(totalReusable);

  if(totalReusable != 0){
    $('#__reusable').html(totalReusable);
  } else{
    //$('#type__reusable').addClass('disabled')
    $('#__reusable').css("display","none");
  }

  if(totalgetStarted != 0){
    $('#__getstarted').html(totalgetStarted);
  } else{
    //$('#type__getstarted').addClass('disabled')
    $('#__getstarted').css("display","none");
  }

  if(totalProducts != 0){
    $('#__ourproducts').html(totalProducts);
  } else{
   // $('#type__ourproducts').addClass('disabled')
    $('#__ourproducts').css("display","none");
  }

  if(totalUsing != 0){
    $('#__using').html(totalUsing);
  } else{
    //$('#type__using').addClass('disabled')
    $('#__using').css("display","none");
  }
 
 
 
  $( ".bfcc-item-master" ).each(function( index ) {
    $(this).show();
    if($(this).hasClass('hideThisContent') && $(this).hasClass('hideThisTitle')){
      $(this).hide();
    }
});
  }

  $(document).on('touchstart click','#bhc_search', function (){ 
      search();
      $('html, body').animate({
        scrollTop: $(".bfbc-navigation").offset().top
    }, 300);
   })

   $(document).on('keydown', function (){ 
    if(window.event.keyCode=='13'){
      search();
      $('html, body').animate({
        scrollTop: $(".bfbc-navigation").offset().top
    }, 300);
     }
    
   });

   $(document).on('keyup','#search', function (){ 
      if($(this).val().length <= 1){
        $('.bfcc-item-master').removeClass('hideThisContent');
        $('.bfcc-item-master').removeClass('hideThisTitle');
        $('.bfcc-item-master').removeClass('showThisContent');
        $('.bfcc-item-master').removeClass('showThisTitle');
        $('.nav_item_faq').removeClass('disabled');
        $('.bfcc-item-master').show();
        $('.bfbc_search_result').hide();
        $("mark").replaceWith(function() { return this.innerHTML; });
      }
    
 })



 $(document).on('change','.bpspc_color_variant ', function (){
  
      let getID = $(this).attr('data-productid');
      let getVariant = $(this).val();


      let getImage = $(this).data('fimage').split(',');
      let getSingleImage = getImage[0];

      $('#item-3').find('img').attr('src',getSingleImage);


      let getRealPrice = $(this).data('discount');
      let getPrice = $(this).data('price');
      if(getRealPrice != 'nodiscount')
      {
        $('#real_price_sn').html(Shopify.formatMoney(getRealPrice, theme.moneyFormat));
        $('#real_price_sn').css('visibility','visible');
      }else{
        $('#real_price_sn').css('visibility','hidden');
      }
   
      $('#price_sn').html(Shopify.formatMoney(getPrice, theme.moneyFormat));





       $(this).parent().parent().parent().find('li').eq(0).find('.bpspc__item_holder__color').find('.bpspc_label').removeClass('bpspc_first_variant'); 
       $(this).parent().parent().parent().parent().find('.bpspc-single_variant_color').find('small').html(getVariant.toUpperCase());
       $(this).parent().parent().parent().parent().parent().find('.bpspc-single-nappy_button__holder').find('.add_product_').attr('data-id',getID);


 });



 $(document).on('change','.ppc_color_variant ', function (){
  let getID = $(this).attr('data-productid');
  let getVariant = $(this).val();
  
  let getRealPrice = $(this).data('discount');
  let getPrice = $(this).data('price');

  if(getRealPrice != 'nodiscount'){
    $('#real_price').html(Shopify.formatMoney(getRealPrice, theme.moneyFormat));
    $('#real_price').css('visibility','visible');
  }else{
    $('#real_price').css('visibility','hidden');
  }
  
  $('#_price').html(Shopify.formatMoney(getPrice, theme.moneyFormat));



  $(this).parent().parent().parent().find('li').eq(0).find('.ppc__item_holder__color').find('.ppc_label').removeClass('first_variant'); 
  $(this).parent().parent().parent().parent().find('.ppcvw_variant_name').find('small').html(getVariant.toUpperCase());
  $(this).parent().parent().parent().parent().parent().find('.ppc_buy_contianer').find('.add_product_').attr('data-id',getID);

});

$(document).on('click','.brcc-item', function (){
    let getId = $(this).attr("id");
    let getOrder = $(this).attr("data-order");
    let getSectionid = $(this).attr("data-identity");

    $(".brcc-item_"+getSectionid+"").removeClass("active");
    $(this).addClass("active");

    $('.brcc-media-container_'+getSectionid+'').removeClass('active');
    $('.brcc-media-container_'+getSectionid+'').css('opacity','0');
    $('#cont_'+getSectionid+'_'+getOrder+'').addClass('active');

    let mobileFixed = 80;

    if( isMobile != null){
        mobileFixed = 100;
    }

    anime({
      targets: '.brcc-item_'+getSectionid+'',
      width: mobileFixed+'%',
      duration: 300,
      easing: 'easeOutQuart'
    });

    anime({
      targets: '#cli_'+getSectionid+'_'+getOrder+'',
      width: [mobileFixed+'%','100%'],
      duration: 300,
      easing: 'easeOutQuart',
      complete: () => {
         anime({
           targets: '#cont_'+getSectionid+'_'+getOrder+'',
           duration: 300,
           easing: 'easeOutQuart',
           opacity: [0,1]
         });
    }
    });

});


$(document).on('click','.action_nav_item', function (){
  let getPostion = $(this).parent().find('.bmcc_parent_hide').attr("data-position");
  if(getPostion == 'close'){
    $(this).parent().find('.bmcc_parent_hide').slideDown({
      start: function () {
        $(this).css({ display: "flex" });
      }
    });
    $(this).parent().find('.bmcc_parent_hide').attr("data-position","open");
  }else{
    $(this).parent().find('.bmcc_parent_hide').slideUp();
    $(this).parent().find('.bmcc_parent_hide').attr("data-position","close");
  }
 

});

$(document).on('click','.bmmc_close_button', function (){


  anime({
    targets: '.bambino_master_mobile_menu_wrapper',
    duration: 500,
    easing: 'easeOutQuart',
    left: ['0%', '-100%']
})


});

$(document).on('click','.bnh_mobile_burger', function (){

     anime({
         targets: '.bambino_master_mobile_menu_wrapper',
         duration: 500,
         easing: 'easeOutQuart',
         left: ['-100%', '0%']
     })
  


});


$(document).on('click','.footer-nav-item_', function (){

  
  let getID = $(this).attr('data-nav');
  let getPosition = $('#footer_nav_child_'+getID+'').attr('data-position');
  
  if(getPosition == 'close')
  {
    $('#footer_nav_child_'+getID+'').slideDown();
    $('#footer_nav_child_'+getID+'').attr('data-position','open');
  }else{
    $('#footer_nav_child_'+getID+'').slideUp();
    $('#footer_nav_child_'+getID+'').attr('data-position','close');
  }
 



});


$(document).on('click','.see_options', function (){
    let getHandle = $(this).attr('data-handle');
    let releaseThis = $(this);


    jQuery.getJSON('/products/'+getHandle+'.js', function(product) {
           $('.product_modal_mobile').css('display','flex');
           $('.modal_bg').css('display','block');
           anime({
                targets: '.product_modal_mobile',
                duration: 500,
                easing: 'easeOutQuart',
                opacity: [0, 1]
           })

           anime({
            targets: '.modal_bg',
            duration: 500,
            easing: 'easeOutQuart',
            opacity: [0, 1]
       })

          
           $('#selling_size_selector').find('li').remove();
         //console.log(product);
           let variantLength = product.variants.length;
           let getfirstVariant = product.variants[0].option1;
           let getVariantControl = product.variants[0].option2;
           let getVairantType = product.options[0].name.toLowerCase();
           let getVariantID = product.variants[0].id;

           let getURL = product.url;

           $('#select_type').html(getVariantControl);

           $('#img_url').attr('href',getURL);
           $('#title_url').attr('href',getURL);
           $('#add_to_cart').attr('data-id',getVariantID);



           //$('#variant_name_modal').html(product.variants[0].public_title);

           //console.log(getVairantType);

           let getTag = product.tags;
           let getTagControl = jQuery.inArray('subscribe',getTag);

           let getProductVariantImage = releaseThis.data('variantcolor');
          // console.log(getProductVariantImage);
           let getSplit = getProductVariantImage.split(",");

   
          

           if(getVairantType == 'colour' || getVairantType == 'color'){
            $('#color_variant_modal').find('li').remove();
            for(let j = 0; j < variantLength; j++){ 
             // console.log(product.variants[j].available)
            if(getSplit[j] != undefined){
            $('#color_variant_modal').append(`<li data-image="${product.variants[j].featured_media.preview_image.src}" ><input type="radio" ${j == 0 ? 'checked = "checked"' : ''} ${product.variants[j].available == false ? 'disabled = "disable"' : ''} data-vname="${product.variants[j].option1}" value="${product.variants[j].title}" data-index="option${j}" data-fimage="" data-productID="${product.variants[j].id}" data-discount="${product.variants[j].compare_at_price}" data-price="${product.variants[j].price}" name="${product.options[0].name}_${product.id}" class="color_variant_modal" id="ProductSelectColor-option-${product.variants[j].id}"><label class="variant_label_modal" for="ProductSelect-option-${product.variants[j].id}"><img src="${getSplit[j]}" width="" height="" loading="lazy" /></label></li>`);
              }
            }  
          }
     
           if(getVariantControl != null || product.options.length >= 2 || product.options[0].name == 'Size' || product.options[0].name == 'size'){
           $('.selling_select').css('display','flex');
           //$('.selling_add').css('display','none');
           //$('.selling_add_to_cart').css('display','none');
           for(let i = 0; i < variantLength; i++){
                
                 let getVariantName = product.variants[i].option1;
              
                 if(getVariantName == getfirstVariant){
                    $('#selling_size_selector').append(`<li class="size_variant_modal ${i == 0 ? 'active' : ''} " data-price="${product.variants[i].price}" data-discount="${product.variants[i].compare_at_price}" data-variant="${product.variants[i].option1}" data-variantoption="${product.variants[i].public_title}" style="display:flex" data-id="${product.variants[i].id}">${product.variants[i].option2} ${product.variants[i].available == false ? '<span>' + soldText + '</span>' : ''}<div class="variant_price_modal"><span class="modal_size_price" id="price___modal">${ product.variants.length > 1 ? Shopify.formatMoney(product.variants[0].price, theme.moneyFormat) : Shopify.formatMoney(product.price, theme.moneyFormat) }</span><span class="modal_size_price" id="real_price___modal" ${product.variants[0].compare_at_price == null ? 'style="display:none;"' : ''}>${ product.variants.length > 1 ? Shopify.formatMoney(product.variants[0].compare_at_price, theme.moneyFormat) : Shopify.formatMoney(product.compare_at_price, theme.moneyFormat) }</span></div></li>`);  
                  }else{
                    $('#selling_size_selector').append(`<li class="size_variant_modal" data-price="${product.variants[i].price}" data-discount="${product.variants[i].compare_at_price}" data-variant="${product.variants[i].option1}" data-variantoption="${product.variants[i].public_title}" style="display:none" data-id="${product.variants[i].id}">${product.variants[i].option2} ${product.variants[i].available == false ? '<span>' + soldText + '</span>' : ''}<div class="variant_price_modal"><span class="modal_size_price" id="price___modal"></span><span class="modal_size_price" id="real_price___modal"></span></div></li>`);  
                  }
              }   
                  
           
          }else{
              $('.selling_select').css('display','none');
              if(getTagControl != -1 ){
              $('.selling_add').css('display','flex');
              }
              $('.selling_add_to_cart').css('display','block');
          }


              if(getTagControl != -1 ){
              $('.selling_subscribe').css('display','block');
              $('#or_modal').css('display','flex');
              }else{
                $('.selling_subscribe').css('display','none');
                $('#or_modal').css('display','none');
              }

    

          $('#selling_title').html(product.title);
          //$('#upper_size_info').html(product.options[1].values[0]);
         
          if(product.variants.length > 0)
          {
            $('#selling_last_price').html(Shopify.formatMoney(product.variants[0].price, theme.moneyFormat));
            if(product.variants[0].compare_at_price != null){
               $('#selling_actual_price').html(Shopify.formatMoney(product.variants[0].compare_at_price, theme.moneyFormat));
               $('#selling_actual_price').show();
             }else{
              $('#selling_actual_price').hide();
             }
          }else{
            $('#selling_last_price').html(Shopify.formatMoney(product.price, theme.moneyFormat));
            if(product.compare_at_price != null){
            $('#selling_actual_price').html(Shopify.formatMoney(product.compare_at_price, theme.moneyFormat));
            $('#selling_actual_price').show();
            }else{
              $('#selling_actual_price').hide();
            }
          }
         
          $('#selling_image').attr('src',product.featured_image);
          $('#buy_button_selling').attr('data-id',product.variants[0].id);
      
    }); 

});

/*if(product.variants[i].option1 != getVariantName2){
  if(getVairantType == 'colour' || getVairantType == 'color'){
   
  }
}*/



$(document).on('click','.selling_modal_close', function (){
 
  anime({
       targets: '.product_modal_mobile',
       duration: 500,
       easing: 'easeOutQuart',
       opacity: [1, 0],
       complete: () => {
        $('.product_modal_mobile').css('display','none');
    }
  })

  anime({
   targets: '.modal_bg',
   duration: 500,
   easing: 'easeOutQuart',
   opacity: [1, 0],
   complete: () => {
    $('.modal_bg').css('display','none');
}
})

});


$(document).on('click','.select_box_default', function (){
     
    let getPosition = $('.select_options').attr('data-position');
    if(getPosition == 'close'){
      $('.select_options').css('display','flex');
      anime({
        targets: '.select_options',
        duration: 500,
        easing: 'easeOutQuart',
        opacity: [0,1],
        bottom: ['0px','35px'],
        complete: () => {
          $('.select_options').attr('data-position','open');
      }
      })
    }else{
      anime({
        targets: '.select_options',
        duration: 500,
        easing: 'easeOutQuart',
        opacity: [1,0],
        bottom: ['35px','0px'],
        complete: () => {
          $(".select_options").css("display","none");
          $('.select_options').attr('data-position','close');
      }
      })
    }
   
});

$(document).on('click','.select_box_modal', function (){
     
  let getPosition = $('.select_options').attr('data-position');
  if(getPosition == 'close'){
    $('.select_options').css('display','flex');
    anime({
      targets: '.select_options',
      duration: 500,
      easing: 'easeOutQuart',
      opacity: [0,1],
      bottom: ['0px','35px'],
      complete: () => {
        $('.select_options').attr('data-position','open');
    }
    })
  }else{
    anime({
      targets: '.select_options',
      duration: 500,
      easing: 'easeOutQuart',
      opacity: [1,0],
      bottom: ['35px','0px'],
      complete: () => {
        $(".select_options").css("display","none");
        $('.select_options').attr('data-position','close');
    }
    })
  }
 
});

$(document).on('click','.size_variant_modal', function (){
      let getProductID = $(this).data('id');
      let getVariantName = $(this).data('variantoption');

       
      let getPrice = $(this).data('price');
      let getActualPrice = $(this).data('discount');

      $('#select_type').html(getVariantName.split('/')[1]);

      $('#selling_last_price').html(Shopify.formatMoney(getPrice, theme.moneyFormat));
      if(getPrice == getActualPrice ||  getActualPrice == null || getActualPrice == "null" || getActualPrice == "0" || getActualPrice == 0){
       $('#selling_actual_price').hide();
      }else{
       $('#selling_actual_price').show();
      }
      $('#selling_actual_price').html(Shopify.formatMoney(getActualPrice, theme.moneyFormat));

      $('.size_variant_modal').removeClass('active');
      $(this).addClass('active');


      //$('#variant_name_modal').html(getVariantName);
      $('#buy_button_selling').attr('data-id',getProductID);
      $('#add_to_cart').attr('data-id',getProductID);
      /*anime({
        targets: '.select_options',
        duration: 500,
        easing: 'easeOutQuart',
        opacity: [1,0],
        bottom: ['36px','0px'],
        complete: () => {
          $(".select_options").css("display","none");
          $('.select_options').attr('data-position','close');
      }
      })*/

});


$(document).on('click','.color_variant_modal', function (){
         let getVarianttype = $(this).data('vname');
         let getVariantLength = $(this).parent().parent().parent().parent().find('.selling_select').find('.select_options').find('li').length;
         let getID = $(this).data('productid');
         let getVariantImage = $(this).parent().data('image');
         
         $('#selling_image').attr('src',getVariantImage);

         let getPrice = $(this).data('price');
         let getActualPrice = $(this).data('discount');

         $('#selling_last_price').html(Shopify.formatMoney(getPrice, theme.moneyFormat));
         if(getPrice == getActualPrice ||  getActualPrice == null || getActualPrice == "null" || getActualPrice == "0" || getActualPrice == 0){
          $('#selling_actual_price').hide();
         }else{
          $('#selling_actual_price').show();
         }
         $('#selling_actual_price').html(Shopify.formatMoney(getActualPrice, theme.moneyFormat));
        

         //$('#variant_name_modal').html(getVarianttype);
         $('#buy_button_selling').attr('data-id',getID);
         $('#add_to_cart').attr('data-id',getID);

         //console.log(getVarianttype+" "+getVariantLength);
         for (let i = 0; i < getVariantLength; i++) {
              let getSizeVariantName = $('.select_options').find('li').eq(i).data('variant');
              if(getVarianttype == getSizeVariantName){
                $('.select_options').find('li').eq(i).css('display','flex');
              }else{
                $('.select_options').find('li').eq(i).css('display','none');
              }
         }  
         $(".select_options").css({"display" : "none" , "bottom" : "0px", "opacity" : 0 });
         
});


$(document).on('click','.pmw_delivery_title', function (){
     let getPosition = $(this).attr('data-position');
     if( getPosition == 'close'){
      $(this).parent().find('.pmw_delivery_items').slideDown();
      $(this).attr('data-position','open');
     }else{
      $(this).parent().find('.pmw_delivery_items').slideUp();
      $(this).attr('data-position','close');
     }
   

});


$(document).on('click','.selling_seperate_header', function (){
  let getPosition = $(this).attr('data-position');
  if( getPosition == 'close'){
   $(this).parent().find('.selling_seperate_content').slideDown();
   $(this).attr('data-position','open');
  }else{
   $(this).parent().find('.selling_seperate_content').slideUp();
   $(this).attr('data-position','close');
  }


});

$(document).on('change','.fpc_color_variant ', function (){

  let getOriginalPrice = $(this).data('discount');
  let getPrice = $(this).data('price');
  let getID = $(this).attr('data-productid');
  if($(this).hasClass('set-save')){
    $(this).parent().parent().parent().parent().parent().parent().find('.fpc_buy_contianer').find('.add_product_').attr('data-id',getID);

    let getImage = $(this).attr('data-fimage');
    let getFirstImage = getImage.split(',');
    let fixedFirstImage = getFirstImage[0];
    //console.log(fixedFirstImage);
    $('.bpsc-right-img_container').find('img').attr('src',fixedFirstImage);

    if($(this).hasClass('set-offer')){
        $('.bso-img').attr('src', fixedFirstImage);
    }

  }else{
    $(this).parent().parent().parent().parent().parent().find('.fpc_buy_contianer').find('.add_product_').attr('data-id',getID);
  }
  

  let getVariantValue = $(this).val();


  /*let getStatus = $(this).attr("data-available");

  if(getStatus == 'soldout'){
      $('#variant_status').css('display','flex');
      $('#variant_status').html('SOLD OUT');
      $(this).parent().parent().parent().parent().parent().find('.fpc_buy_contianer').find('.featured_add_to_cart').prop( "disabled", true );
      $(this).parent().parent().parent().parent().parent().find('.fpc_buy_contianer').find('.featured_add_to_cart').addClass('disable');
  }else{
      $('#variant_status').html('');
      $('#variant_status').hide();
      $(this).parent().parent().parent().parent().parent().find('.fpc_buy_contianer').find('.featured_add_to_cart').prop( "disabled", false );
      $(this).parent().parent().parent().parent().parent().find('.fpc_buy_contianer').find('.featured_add_to_cart').removeClass('disable');
  }*/


  $('.fpcvw_variant_name').find('small').html(getVariantValue);


  let getColorVariantName = $(this).data('vname');
  let getSizeLength = $('.pdp_size_dropdown-feat').find('li').length;

  let getCurrent = $('.pdp_size_dropdown-feat').attr('data-current');


  for ( let i = 0; i < getSizeLength; i++ ){
       let getLiName = $('.pdp_size_dropdown-feat').find('li').eq(i).data('productcolor');
       let getSize = $(".pdp_size_dropdown-feat").find("li").eq(i).attr('data-productsize');

            if(getLiName ==  getColorVariantName && getCurrent == getSize){
    
      if($(".pdp_size_dropdown-feat").find("li").eq(i).attr('data-status') == 'available'){
          $('#variant_status').hide();
          $('#variant_status').html('')
          $('.feat_buy_btn').prop( "disabled", false );
          $('.feat_buy_btn').removeClass('disable');
          $('.feat_buy_btn').html(atcText);
      }else{
          $('#variant_status').show();
          $('.feat_buy_btn').prop( "disabled", true );
          $('.feat_buy_btn').addClass('disable');
          $('.feat_buy_btn').html(soldText);
          $('#variant_status').html(soldText)

      }
    }

    
       if(getLiName ==  getColorVariantName) {
        $('.pdp_size_dropdown-feat').find('li').eq(i).removeClass('displayno_pdp');
       }else{
        $('.pdp_size_dropdown-feat').find('li').eq(i).addClass('displayno_pdp');
       }
  }

  if(getOriginalPrice == 'nodiscount') {
    $('#fpc_original_price').css({"visibility":"hidden", "position":"absolute"});
   }else{
    $('#fpc_original_price').html(Shopify.formatMoney(getOriginalPrice, theme.moneyFormat));
    $('#fpc_original_price').css({"visibility":"visible", "position":"relative"});
   }
  $('#fpc_price').html(Shopify.formatMoney(getPrice, theme.moneyFormat));



}); 


$(document).on('click','.bam_modal_close', function (){
     anime({
      targets: '.bambino-bam-modal-container',
      duration: 500,
      easing: 'easeOutQuart',
      opacity: [1,0],
      complete: () => {
        $('.bambino-bam-modal-container').css('display','none');
    }
     })

}); 


$(document).on('click','.size_guide_close', function (){
  anime({
   targets: '.size_guide_container',
   duration: 500,
   easing: 'easeOutQuart',
   opacity: [1,0],
   complete: () => {
     $('.size_guide_container').css('display','none');
 }
  })

}); 

$(document).on('click','.close_ghost', function (){
  anime({
   targets: '.size_guide_container',
   duration: 500,
   easing: 'easeOutQuart',
   opacity: [1,0],
   complete: () => {
     $('.size_guide_container').css('display','none');
 }
  })

}); 

$(document).on('click','#size_guide', function (){
  $('.size_guide_container').css('display','flex');
  anime({
   targets: '.size_guide_container',
   duration: 500,
   easing: 'easeOutQuart',
   opacity: [0,1],

  })

}); 

$(document).on('click','.stc_header', function (){
  let getPosition = $(this).attr('data-position');
  if(getPosition == 'close'){
       $('.stc_content').slideDown();
       $('.stc_header').attr('data-position','open');
  }else{
    $('.stc_content').slideUp();
    $('.stc_header').attr('data-position','close');
  } 
 

}); 

$(document).on('click','.nPDP_stc_header', function (){
  let getPosition = $(this).attr('data-position');
  if(getPosition == 'close'){
       $('.nPDP_stc_content').slideDown();
       $('.nPDP_stc_header').attr('data-position','open');
       $('.nPDP_stc_arrow').css({
         'transform':'rotate(225deg)',
         'top':'-1px'
       });
       $('.nPDP_stc_header_content').find('h3').html('Close financing options');
  }else{
    $('.nPDP_stc_content').slideUp();
    $('.nPDP_stc_header').attr('data-position','close');
    $('.nPDP_stc_arrow').css({
      'transform':'rotate(45deg)',
      'top':'-5px'
    });
    $('.nPDP_stc_header_content').find('h3').html('See financing options');
  } 
 

}); 

$(document).on('click', '#create_customer' , function(){
     /*   let getEmail = $('#RegisterForm-email').val();
        let getPassword = $('RegisterForm-password').val();
        if ($('.custom_error')[0]){
        $('.custom_error').remove();
        }
        let TextError = '<div class"custom_error"><h2 class="form__message" tabindex="-1" autofocus=""><span class="visually-hidden">Error</span><svg aria-hidden="true" focusable="false" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path></svg>Please adjust the following:</h2></div>';
        if(getEmail == '' || create_customer == null || create_customer == ''){
            $('#create_customer').append(TextError);
            return false;
        }if(getPassword == '' || getPassword == null || getPassword == ''){
            $('#create_customer').append(TextError);
            return false;
        }*/

       
});

let getThisPosition;
$(document).on('click', '.wiify-item-header' , function(){

     getThisPosition = $(this).attr('data-position');

    if(getThisPosition == 'close'){
        $(this).parent().find('.wiify-item-content').slideDown();
        $(this).attr('data-position','open');
        $(this).find('.wiify-item_button').html('-');
    }else{
      $(this).parent().find('.wiify-item-content').slideUp();
      $(this).attr('data-position','close');
      $(this).find('.wiify-item_button').html('+');
    }
  
});

$(document).on('change', '.multibuy_radio' , function(){

 let getValue = $(this).val(); 
 $('.pmw_holdQuantity').attr("value",getValue); 
 $('#add_to_cart').attr('data-quantity',getValue);

});


$(document).on('change', '.rc_widget__option__plans__dropdown' , function(){

    
    let getSellingPlanID = $(this).val();
    $('#add_to_cart').attr('data-selling-plan-id',getSellingPlanID);
    //console.log(getSellingPlanID);

});

$(document).on('change', '.rc-radio__input' , function(){

  //console.log('change radio');

});

$(document).on('change', '.selling_plan_input' , function(){

    let getValue = $(this).val();

   

    if(getValue == 'onetime'){
       $('.subs_options').slideUp();
       $('.pdp_buy').attr('data-onetime',true);
       $('#add_to_cart').html(atcText);
       $('.qa-button').html(atcText);

    }else{
      $('.subs_options').slideDown();
      $('.pdp_buy').attr('data-onetime',false);
      $('#add_to_cart').html('ADD SUBSCRIPTION TO CART');
      $('.qa-button').html('ADD SUBSCRIPTION TO CART');
    }

});


$(document).on('change', '.nPDP_selling' , function(){

  let getValue = $(this).attr('data-selling');
  let getID = $(this).val();
  $('.pdp_buy').attr('data-id',getID);
  //console.log(getValue);

});




let eyeControl = 0;

$(document).on('click', '.show_pass_' , function(){
     if(eyeControl == 0){
      $(this).parent().find('input').attr('type','text');
      $(this).find('img').attr('src', 'https://cdn.shopify.com/s/files/1/0665/2153/0602/files/iconmonstr-eye-lined.svg?v=1685283422');
      eyeControl = 1;
     }else{
      $(this).parent().find('input').attr('type','password');
      $(this).find('img').attr('src', 'https://cdn.shopify.com/s/files/1/0665/2153/0602/files/iconmonstr-eye-off-lined.svg?v=1685283422');
      eyeControl = 0;
     }
    

});


$(document).on('click', '.selling_plan_groups__' , function(){

     let getSellingPlanid = $(this).attr('data-selling-id');

     $('.pdp_buy').attr('data-selling-plan-id',getSellingPlanid);
     
     $('.selling_plan_groups__').removeClass('active');
     $(this).addClass('active');
    
});
$(document).on('click', '.ghost_close' , function(){

  anime({
    targets: '.bambino-bam-modal-container',
    duration: 500,
    easing: 'easeOutQuart',
    opacity: [1,0],
    complete: () => {
      $('.bambino-bam-modal-container').css('display','none');
  }
   })
 
});



$(document).on('click', '.bsmc_frequency_item' , function(){

  let getSellingPlanid = $(this).attr('data-selling-id');
  
  $('.subscribe_modal_btn').attr('data-selling-plan-id',getSellingPlanid);
  
  $('.bsmc_f').removeClass('active');
  $(this).addClass('active');
 
});


$(document).on('click', '.badge_subscribe' , function(){

  
   
  let getModalid = $(this).attr('data-modalid');
  let parseID = getModalid.split('_');
  let getRealID = parseID[1]+'_'+parseID[2];

  $('.bambino-drawer').scrollTop(0);
  $('.bambino-drawer').css('overflow-y','hidden');

 // console.log(getRealID);
  anime({
     targets : '#modal_'+getRealID+'',
     duration:500,
     easing: 'easeOutQuart',
     opacity: [0,1],
     complete: () => {
       $('#modal_'+getRealID+'').css('display','flex');
   }

  });

});

$(document).on('click', '.porduct_subcribe' , function(){

  
   
   let getModalid = $(this).attr('data-modalid');
   let parseID = getModalid.split('_');
   let getRealID = parseID[1]+'_'+parseID[2];

   //console.log(getRealID);
   anime({
      targets : '#modal_'+getRealID+'',
      duration:500,
      easing: 'easeOutQuart',
      opacity: [0,1],
      complete: () => {
        $('#modal_'+getRealID+'').css('display','flex');
    }

   });
 
});


$(document).on('click', '.bsmc-close' ,function(){

 
  $('.bambino-drawer').css('overflow-y','auto');
 
  anime({
     targets : '.bambino-subscribe-modal-container',
     duration:500,
     easing: 'easeOutQuart',
     opacity: [1,0],
     complete: () => {
       $('.bambino-subscribe-modal-container').css('display','none');
   }

  });

});

$(document).on('click', '.bsmc_ghost', function(){


  anime({
     targets : '.bambino-subscribe-modal-container',
     duration:500,
     easing: 'easeOutQuart',
     opacity: [1,0],
     complete: () => {
       $('.bambino-subscribe-modal-container').css('display','none');
   }

  });

});


$(document).on('click', '#klaviyo_trigger', function(){
      let getFormid = $(this).attr('data-formid');
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', getFormid ]);
  });



  $(document).on('change','.nPDP_cts_pdp', function (){

    let get_price = $(this).attr('data-price');
    let get_discount = $(this).attr('data-discount');
    let get_variant_name = $(this).val();
    let get_variant_name_handlize = $(this).attr('data-vname');
    let get_variant_images = $(this).attr('data-fimage').split(',');
    let getPercent = $(this).attr('data-percent');
    let getVid = $(this).attr('data-productid'); 


    let getCalcAmo = $(this).attr('data-discount') - $(this).attr('data-price');
    $('#discount_price_badge_cs').html(Shopify.formatMoney(getCalcAmo, theme.moneyFormat));




    $('#ncc_real_price').html(Shopify.formatMoney(get_price, theme.moneyFormat));
    $('#ncc_compare_price').html(Shopify.formatMoney(get_discount, theme.moneyFormat));
    $('#nPDP_variant_color_name').html(get_variant_name);
    $('.ncc-pImage').find('img').attr('src',get_variant_images[0]);
    $('#percHolder_cs').html(getPercent);

    $('#cs_button').attr('data-id',getVid);

    if(get_discount != "nodiscount"){
        $('.offer_badge').removeClass('hide_discount');
    }else{
        $('.offer_badge').addClass('hide_discount'); 
        $('#ncc_compare_price').html('');
    }
 
    //$('#cs_button').attr('data-id',get_variant_id);



    let getSizeOfSize = $('.cs_nPDP-size').length;
    $('.cs_nPDP-size').addClass('displayno_pdp');
    $('.cs_nPDP-size').removeClass('active');

    let control = 0;
    for(let i = 0; i < getSizeOfSize; i++){
        let getVariantLoopName = $('.cs_nPDP-size').eq(i).attr('data-productcolor');
        if(get_variant_name_handlize == getVariantLoopName){
          //console.log('break');
          let getSta = $('.cs_nPDP-size').eq(i).attr('data-status');
          if(getSta == 'available' && control == 0){
               control = 1;
               $('.cs_nPDP-size').eq(i).addClass('active');
               let getID = $('.cs_nPDP-size').eq(i).attr('data-productmasterid');
               let getSize = $('.cs_nPDP-size').eq(i).attr('data-productsize');
               $('#cs_button').attr('data-id',getID);
               $('#variant_size_name').html(getSize); 
          }  
          $('.cs_nPDP-size').eq(i).removeClass('displayno_pdp');
        }
    }


  
  });




  $(document).on('change','.cs_size_', function (){

    let get_variant_name = $(this).attr('data-size');
    let get_variant_id = $(this).attr('data-productid');

    $('.cs_nPDP-size').removeClass('active');

    $('#variant_size_name').html(get_variant_name); 
    $('#cs_button').attr('data-id',get_variant_id);
    $(this).parent().parent().addClass('active');

  });
  

  $(document).on('click','.nPDP-description_title_wrapper', function (){
    let getPosition = $(this).parent().find('.nPDP-description_text').attr('data-position');

    if(getPosition == 'close'){
    $(this).parent().find('.nPDP-description_text').slideDown();
    $(this).parent().find('.nPDP-description_text').attr('data-position','open');
    $(this).find('.nPDP-desc-arrow').addClass('rotateArrow');
    }else{
    $(this).parent().find('.nPDP-description_text').slideUp();
    $(this).parent().find('.nPDP-description_text').attr('data-position','close');
    $(this).find('.nPDP-desc-arrow').removeClass('rotateArrow');    
    }
    /*let getPosition = $(this).parent().find('.nPDP-description_text').attr('data-position');
    if(getPosition == 'open'){
      $(this).parent().find('.nPDP-description_text').attr('data-position','close');
      $(this).parent().find('.nPDP-description_text').slideUp();
      $(this).find('.nPDP-desc-arrow').removeClass('rotateArrow');
    }
    else{
    $('.nPDP-description_text').slideUp();
    $('.nPDP-desc-arrow').removeClass('rotateArrow');
    $('.nPDP-description_text').attr('data-position','close');
    $(this).parent().find('.nPDP-description_text').attr('data-position','open');
    $(this).parent().find('.nPDP-description_text').slideDown();
    $(this).find('.nPDP-desc-arrow').addClass('rotateArrow');
  }*/
});


let getImageList;
let realImages

let orderControl = 0;
$( document ).ready(function() {
let getDataOrder = $('#pZoom').attr('data-order');
if(orderControl != getDataOrder){
   orderControl = getDataOrder;     
}
});

let clickControl = 0

$(document).on('click','.nPDP-magnifier', function (){
  $('body').css('overflow','hidden');
  $('.zoom_wrapper').css('display','flex');
  $('#pZoom').find('div').remove();
  let getDataOrderFirst = $('#pZoom').attr('data-order');

  

  getImageList = $('#pZoom').attr('data-image').split(',');
  let getImageList_ = $('#pZoom').attr('data-image');

  if(getImageList_[getImageList_.length - 1] == ','){
  getImageList_ = getImageList_.slice(0, -1);
  }

  realImages = getImageList_.split(',');

  $('#pZoom').attr('data-image' , getImageList_);
  $('#pZoom').append('<div class="zoom-image"><img src="'+realImages[getDataOrderFirst]+'" height="1500" loading="lazy" sizes="100vw"></div>');
  let getWidthofScreen = $('body').outerHeight() / 2;
  //console.log(getWidthofScreen);
  $('.zoom_wrapper').scrollTop(getWidthofScreen);

  anime({
      targets: '.zoom_wrapper',
      duration: 500,
      easing: 'easeInOutQuad',
      opacity: [0,1]
  })

});

$(document).on('click','.zoom-Modal-BG', function (){
  $('body').css('overflow','auto');
  anime({
      targets: '.zoom_wrapper',
      duration: 500,
      easing: 'easeInOutQuad',
      opacity: [1,0],
      complete: function(anim) {
        $('.zoom_wrapper').css('display','none');
     }
  })

});



$(document).on('click', '.za-right', function(){



    let maxImageValue = realImages.length;
    if(orderControl == maxImageValue-1){
       orderControl = 0;
       $('.zoom-image').find('img').attr('src', realImages[orderControl]);
    }else{
       orderControl++;
      $('.zoom-image').find('img').attr('src', realImages[orderControl])
    }

    let getCenterPoint = $('.zoom_wrapper').outerHeight() / 2;
    $('.zoom_wrapper').scrollTop(getCenterPoint);
});

$(document).on('click', '.za-left', function(){

  if(orderControl == 0){
     orderControl = realImages.length -1;
     $('.zoom-image').find('img').attr('src', realImages[orderControl]);
  }else{
     orderControl--;
    $('.zoom-image').find('img').attr('src', realImages[orderControl])
  }

  let getCenterPoint = $('.zoom_wrapper').outerHeight() / 2;
  $('.zoom_wrapper').scrollTop(getCenterPoint);
});

let basicMeger = 1;

$(document).on('click', '.zoom-in', function(){
  if(basicMeger < 2.5){
    $(this).css('opacity','1');
    $('.zoom-out').css('opacity','1');
       basicMeger = basicMeger + 0.5;
   
       anime({
           targets: '.zoom-image',
           scale: basicMeger,
           duration: 500,
           easing: 'easeInOutQuad',
       })  
       
       $('.zoom-info').html('x'+basicMeger.toFixed(1));
      }else{
         $(this).css('opacity','0.3');
         basicMeger = 2.5;
      }
});

$(document).on('click', '.zoom-out', function(){
       if(basicMeger > 1){
        $('.zoom-in').css('opacity','1');
        $(this).css('opacity','1');
       basicMeger = basicMeger - 0.5;
  anime({
      targets: '.zoom-image',
      scale: basicMeger,
      duration: 500,
      easing: 'easeInOutQuad',
  })  
  $('.zoom-info').html('x'+basicMeger.toFixed(1));    
} else{
        $(this).css('opacity','0.3');
         basicMeger = 1;
}
});


$(document).on('click', '.htuc-title', function(){

       let getStatus = $(this).attr('data-status');
       if(getStatus == 'close'){
           $(this).parent().find('.htuc-content').slideDown();
           $(this).attr('data-status','open');
           $(this).find('.htuc_door').html('-');
       }else{
           $(this).parent().find('.htuc-content').slideUp();
           $(this).attr('data-status','close');
           $(this).find('.htuc_door').html('+');
       }

})


$(document).on('click', '.nPDP-title', function(){
      let getID = $(this).attr('data-id');
      $('.htu_items').removeClass('active');
      $('.nPDP-title').removeClass('active');
      $('#'+getID).addClass('active');
      $(this).addClass('active');
});


$(document).on('click', '.nPDP-witb-item-title', function(){

     let getStatus = $(this).attr('data-status');
     if(getStatus == 'close'){
         $(this).find('.nPDP-witb-item-btn').html('-');
         $(this).attr('data-status','open');
         $(this).parent().find('.nPDP-witb-item-content').slideDown({
          start: function () {
            $(this).css({
              display: "flex"
            })
          }
        }); 
     }else{
        $(this).attr('data-status','close');
        $(this).find('.nPDP-witb-item-btn').html('+');
        $(this).parent().find('.nPDP-witb-item-content').slideUp(); 
     } 

});


$(document).on('click', '.variant_list', function(){

      $('.variant_list').removeClass('active');
      $(this).addClass('active');

      let getImaage = $(this).attr('data-images');
      let getVarname = $(this).attr('data-varname');
      $(this).parent().parent().parent().parent().parent().find('.witb-left').find('.nPDP-witb-lef-img').find('.varImage').attr('src',getImaage);
      $('.witb-zoom_container').find('img').attr('src',getImaage);

      $('#witb__variant_title').html(getVarname);

});

$(document).on('click', '.witb-zoom', function(){
  $('.witb-zoom_container').css('display','flex');
  anime({
    targets: '.witb-zoom_container',
    duration: 500,
    easing: 'easeInOutQuad',
    opacity: [0,1]
})
});

$(document).on('click', '.witb-zoom-close , .witb-zoom-BG ', function(){
  anime({
    targets: '.witb-zoom_container',
    duration: 500,
    easing: 'easeInOutQuad',
    opacity: [1,0],
    complete: function(anim) {
      $('.witb-zoom_container').css('display','none');
   }
})
});


$(document).on('click', '.product-zoom-close , .witb-zoom-BG ', function(){
  $('body').css('overflow','auto');
  anime({
      targets: '.zoom_wrapper',
      duration: 500,
      easing: 'easeInOutQuad',
      opacity: [1,0],
      complete: function(anim) {
        $('.zoom_wrapper').css('display','none');
     }
  })
});

$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  if(isMobile != null){
    var elementBottom = (elementTop + $(this).outerHeight());
  }else{
    var elementBottom = (elementTop + $(this).outerHeight()) - ($('.hTuc').outerHeight() + 200);
  }

  var viewportTop = $(window).scrollTop();
  var viewportBottom = (viewportTop + $(window).height());

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

let animationControl = true;

$(window).on('scroll', function() {

  if($('.new-PDP-wrapper')[0]){
  
  let $scrolled = $('.new-PDP-wrapper');

  let docPosition = $(document).scrollTop();
  let buttonPosition = $('#add_to_cart').offset().top;

  let divPosition = $('.product_info_wrapper').outerHeight();
  let footerDetect = $(document).outerHeight() - $('body').outerHeight();

  
  if(isMobile != null){
    let megerSlide;
    let megerSlide2;



  if(isMobile != 'iPhone'){
      megerSlide = 101;
      megerSlide2 = -11;
  }  else{
      megerSlide = 101;
      megerSlide2 = 0;
  }

 
  if (docPosition >= -100 && docPosition < buttonPosition ) {
 

    if(animationControl == false){
      anime({
          targets: '.nPDP-quick-add-wrapper',
          duration: 500,
          easing: 'easeInOutQuad',
          bottom: (megerSlide * -1)+'px',
          begin: function(anim) {
            animationControl = true;
          }
      })
      anime({
        targets: '.gorgias-chat-key-1spa6uy',
        duration: 500,
        easing: 'easeInOutQuad', 
        bottom: '10px',
        begin: function(anim) {
          animationControl = false;
        }
      })
    }
  
  

  }else{
    if(docPosition >= (footerDetect-300)){
      if(animationControl == false){
      anime({
          targets: '.nPDP-quick-add-wrapper',
          duration: 500,
          easing: 'easeInOutQuad',
          bottom: (megerSlide * -1)+'px',
          begin: function(anim) {
            animationControl = true;
          }
      })
      anime({
        targets: '.gorgias-chat-key-1spa6uy',
        duration: 500,
        easing: 'easeInOutQuad',
        bottom: '10px',
        begin: function(anim) { 
          animationControl = true;
        }
      })
    }
    }else{
      if(animationControl == true){
      anime({
        targets: '.nPDP-quick-add-wrapper',
        duration: 500,
        easing: 'easeInOutQuad',
        bottom: megerSlide2+'px',
        begin: function(anim) {
          animationControl = false;
        }
    })
    anime({
      targets: '.gorgias-chat-key-1spa6uy',
      duration: 500,
      easing: 'easeInOutQuad',
      bottom: '10px',
      begin: function(anim) { 
        animationControl = true;
      }
    })
    }
  }
  }
}else{
  if (docPosition >= 0 && docPosition >= (divPosition + 100)  ) {
 
    if(docPosition == footerDetect)
    {
      if(animationControl == false){
        anime({
            targets: '.nPDP-quick-add-wrapper',
            duration: 500,
            easing: 'easeInOutQuad',
            bottom: '-101px',
            begin: function(anim) {
              animationControl = true;
            }
        })

        anime({
          targets: '.gorgias-chat-key-1spa6uy',
          duration: 500,
          easing: 'easeInOutQuad',
          bottom: '10px',
          begin: function(anim) { 
            animationControl = true;
          }
        })
      }
    
    }else{
      if(animationControl == true){
        anime({
          targets: '.nPDP-quick-add-wrapper',
          duration: 500,
          easing: 'easeInOutQuad',
          bottom: '0px',
          begin: function(anim) {
            animationControl = false;
          }
      })
      anime({
        targets: '.gorgias-chat-key-1spa6uy',
        duration: 500,
        easing: 'easeInOutQuad', 
        bottom: '100px',
        begin: function(anim) {
          animationControl = false;
        }
      })
      }
    }
   

  }
  else{
    if(animationControl == false){
      anime({
          targets: '.nPDP-quick-add-wrapper',
          duration: 500,
          easing: 'easeInOutQuad',
          bottom: '-101px',
          begin: function(anim) {
            animationControl = true;
          }
      })
      anime({
        targets: '.gorgias-chat-key-1spa6uy',
        duration: 500,
        easing: 'easeInOutQuad', 
        bottom: '10px',
        begin: function(anim) {
          animationControl = true;
        }
      })
    }
  }
}
    }
  
});


$(document).on('click', '.htuc-ar-right', function(){

    let getWidth = $('.nPDP-how-to-use-nav').find('ul').innerWidth();
    let getLastNode = $('.nPDP-how-to-use-nav').find('ul').find('li').length;
    let getOrder = $(this).attr('data-order')-1;
    $('.nPDP-how-to-use-nav').find('ul').animate({
       scrollLeft: getWidth
    },{
       duration: 500,
       complete : function() {
        $('.htuc-ar-left').css('display','block');
        $('.htuc-ar-right').css('display','none');
        $('.htuc-title').attr('data-status','close');
        if(getLastNode > 1){
        $('.nPDP-how-to-use-nav').find('ul').find('li').removeClass('active');
        $('.nPDP-how-to-use-nav').find('ul').find('li').eq(getLastNode-1).addClass('active');
        $('.nPDP-how-to-use_content').find('.all_container').find('.htu_items').removeClass('active');
        $('.nPDP-how-to-use_content').find('.all_container').find('.htu_items').eq(getOrder).addClass('active');
        }
       }
    });
    
    

});

$(document).on('click', '.htuc-ar-left', function(){

  let getLastNode = $('.nPDP-how-to-use-nav').find('ul').find('li').length;
  let getOrder = $(this).attr('data-order')-1;
  $('.nPDP-how-to-use-nav').find('ul').animate({
     scrollLeft: 0
  },{
    duration: 500,
    complete : function() {
     $('.htuc-ar-left').css('display','none');
     $('.htuc-ar-right').css('display','block');
     $('.htuc-title').attr('data-status','close');
     if(getLastNode > 1){
      $('.nPDP-how-to-use-nav').find('ul').find('li').removeClass('active');
      $('.nPDP-how-to-use-nav').find('ul').find('li').eq(0).addClass('active');
      $('.nPDP-how-to-use_content').find('.all_container').find('.htu_items').removeClass('active');
      $('.nPDP-how-to-use_content').find('.all_container').find('.htu_items').eq(getOrder).addClass('active');
     }
    }
 });
  

});

$('.nPDP-how-to-use-nav').find('ul').on('scroll', function(){
      let getWidth = $('.nPDP-how-to-use-nav').find('ul').get(0).scrollWidth - $('body').get(0).scrollWidth;
     if($(this).scrollLeft() == getWidth){
        $('.htuc-ar-left').css('display','block');
        $('.htuc-ar-right').css('display','none');
     }
     if($(this).scrollLeft() == 0){
        $('.htuc-ar-left').css('display','none');
        $('.htuc-ar-right').css('display','block');
     }
  
})

/*if($('.zoom_wrapper')[0]){
$('.zoom_wrapper').mousemove(function(e) {
  var percent = e.clientY / $(window).height();
  $('.zoom_wrapper').scrollTop($(document).height() * percent);
});
}*/


$("a[href^='#']").click(function(e) {
  e.preventDefault();
  let getId = $(this).attr('href');

  if( getId == '#htu_start'){
    var position = $($(this).attr("href")).offset().top - 100; 
  }else{
	
    var position = $($(this).attr("href")).offset().top;
  }
	$("body, html").animate({
		scrollTop: position
	} /* speed */ );
});











